/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: any;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  UUID: any;
};

export type AccessLane = {
  __typename?: 'AccessLane';
  fromAreaId?: Maybe<Scalars['Int']>;
  hasAnpr: Scalars['Boolean'];
  hasQrReader: Scalars['Boolean'];
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  pgsEnabled: Scalars['Boolean'];
  senseIqId: Scalars['Int'];
  site?: Maybe<Site>;
  siteId: Scalars['UUID'];
  toAreaId?: Maybe<Scalars['Int']>;
};

export type AccessLaneDto = {
  __typename?: 'AccessLaneDTO';
  fromAreaId?: Maybe<Scalars['Int']>;
  hasAnpr: Scalars['Boolean'];
  hasQrReader: Scalars['Boolean'];
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  pgsEnabled: Scalars['Boolean'];
  senseIqId: Scalars['Int'];
  site?: Maybe<SiteDto>;
  siteId: Scalars['UUID'];
  toAreaId?: Maybe<Scalars['Int']>;
};

export type AccessLaneFilterInput = {
  and?: InputMaybe<Array<AccessLaneFilterInput>>;
  fromAreaId?: InputMaybe<IntOperationFilterInput>;
  hasAnpr?: InputMaybe<BooleanOperationFilterInput>;
  hasQrReader?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccessLaneFilterInput>>;
  pgsEnabled?: InputMaybe<BooleanOperationFilterInput>;
  senseIqId?: InputMaybe<IntOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  toAreaId?: InputMaybe<IntOperationFilterInput>;
};

export type AccessLaneInput = {
  fromAreaId?: InputMaybe<Scalars['Int']>;
  hasAnpr: Scalars['Boolean'];
  hasQrReader: Scalars['Boolean'];
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  pgsEnabled: Scalars['Boolean'];
  senseIqId: Scalars['Int'];
  site?: InputMaybe<SiteInput>;
  siteId: Scalars['UUID'];
  toAreaId?: InputMaybe<Scalars['Int']>;
};

export type AccessLaneSortInput = {
  fromAreaId?: InputMaybe<SortEnumType>;
  hasAnpr?: InputMaybe<SortEnumType>;
  hasQrReader?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pgsEnabled?: InputMaybe<SortEnumType>;
  senseIqId?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  toAreaId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AccessLanesCollectionSegment = {
  __typename?: 'AccessLanesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<AccessLane>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type AccessTime = {
  __typename?: 'AccessTime';
  area?: Maybe<Area>;
  areaId?: Maybe<Scalars['UUID']>;
  dayOfWeek: DayOfWeek;
  end?: Maybe<Scalars['Int']>;
  hasAccess: Scalars['Boolean'];
  id: Scalars['UUID'];
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['UUID']>;
  siteParker?: Maybe<SiteParker>;
  siteParkerId?: Maybe<Scalars['UUID']>;
  start?: Maybe<Scalars['Int']>;
};

export type AccessTimeDto = {
  __typename?: 'AccessTimeDTO';
  area?: Maybe<AreaDto>;
  areaId?: Maybe<Scalars['UUID']>;
  dayOfWeek: DayOfWeek;
  end?: Maybe<Scalars['Int']>;
  hasAccess: Scalars['Boolean'];
  id: Scalars['UUID'];
  site?: Maybe<SiteDto>;
  siteId?: Maybe<Scalars['UUID']>;
  siteParker?: Maybe<SiteParkerDto>;
  siteParkerId?: Maybe<Scalars['UUID']>;
  start?: Maybe<Scalars['Int']>;
};

export type AccessTimeFilterInput = {
  and?: InputMaybe<Array<AccessTimeFilterInput>>;
  area?: InputMaybe<AreaFilterInput>;
  areaId?: InputMaybe<UuidOperationFilterInput>;
  dayOfWeek?: InputMaybe<DayOfWeekOperationFilterInput>;
  end?: InputMaybe<IntOperationFilterInput>;
  hasAccess?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<AccessTimeFilterInput>>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  siteParker?: InputMaybe<SiteParkerFilterInput>;
  siteParkerId?: InputMaybe<UuidOperationFilterInput>;
  start?: InputMaybe<IntOperationFilterInput>;
};

export type AccessTimeInput = {
  area?: InputMaybe<AreaInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek: DayOfWeek;
  end?: InputMaybe<Scalars['Int']>;
  hasAccess: Scalars['Boolean'];
  id: Scalars['UUID'];
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteParker?: InputMaybe<SiteParkerInput>;
  siteParkerId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Int']>;
};

export type AccessTimeSortInput = {
  area?: InputMaybe<AreaSortInput>;
  areaId?: InputMaybe<SortEnumType>;
  dayOfWeek?: InputMaybe<SortEnumType>;
  end?: InputMaybe<SortEnumType>;
  hasAccess?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  siteParker?: InputMaybe<SiteParkerSortInput>;
  siteParkerId?: InputMaybe<SortEnumType>;
  start?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AccessTimesCollectionSegment = {
  __typename?: 'AccessTimesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<AccessTime>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export type Area = {
  __typename?: 'Area';
  accessTimes?: Maybe<Array<Maybe<AccessTime>>>;
  bays?: Maybe<Array<Maybe<Bay>>>;
  calculationType?: Maybe<Scalars['String']>;
  capacities?: Maybe<Array<Maybe<Capacity>>>;
  capacity: Scalars['Int'];
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  pgsEnabled: Scalars['Boolean'];
  senseIqId: Scalars['Int'];
  senseIqParentId?: Maybe<Scalars['Int']>;
  site?: Maybe<Site>;
  siteId: Scalars['UUID'];
  tariffs?: Maybe<Array<Maybe<Tariff>>>;
};

export type AreaDto = {
  __typename?: 'AreaDTO';
  accessTimes?: Maybe<Array<Maybe<AccessTimeDto>>>;
  bays?: Maybe<Array<Maybe<BayDto>>>;
  calculationType?: Maybe<Scalars['String']>;
  capacities?: Maybe<Array<Maybe<CapacityDto>>>;
  capacity: Scalars['Int'];
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<PermissionDto>>>;
  pgsEnabled: Scalars['Boolean'];
  senseIqId: Scalars['Int'];
  senseIqParentId?: Maybe<Scalars['Int']>;
  site?: Maybe<SiteDto>;
  siteId: Scalars['UUID'];
  tariffs?: Maybe<Array<Maybe<TariffDto>>>;
};

export type AreaFilterInput = {
  accessTimes?: InputMaybe<ListFilterInputTypeOfAccessTimeFilterInput>;
  and?: InputMaybe<Array<AreaFilterInput>>;
  bays?: InputMaybe<ListFilterInputTypeOfBayFilterInput>;
  calculationType?: InputMaybe<StringOperationFilterInput>;
  capacities?: InputMaybe<ListFilterInputTypeOfCapacityFilterInput>;
  capacity?: InputMaybe<IntOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AreaFilterInput>>;
  permissions?: InputMaybe<ListFilterInputTypeOfPermissionFilterInput>;
  pgsEnabled?: InputMaybe<BooleanOperationFilterInput>;
  senseIqId?: InputMaybe<IntOperationFilterInput>;
  senseIqParentId?: InputMaybe<IntOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  tariffs?: InputMaybe<ListFilterInputTypeOfTariffFilterInput>;
};

export type AreaInput = {
  accessTimes?: InputMaybe<Array<InputMaybe<AccessTimeInput>>>;
  bays?: InputMaybe<Array<InputMaybe<BayInput>>>;
  calculationType?: InputMaybe<Scalars['String']>;
  capacities?: InputMaybe<Array<InputMaybe<CapacityInput>>>;
  capacity: Scalars['Int'];
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<PermissionInput>>>;
  pgsEnabled: Scalars['Boolean'];
  senseIqId: Scalars['Int'];
  senseIqParentId?: InputMaybe<Scalars['Int']>;
  site?: InputMaybe<SiteInput>;
  siteId: Scalars['UUID'];
  tariffs?: InputMaybe<Array<InputMaybe<TariffInput>>>;
};

export type AreaSortInput = {
  calculationType?: InputMaybe<SortEnumType>;
  capacity?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pgsEnabled?: InputMaybe<SortEnumType>;
  senseIqId?: InputMaybe<SortEnumType>;
  senseIqParentId?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AreasCollectionSegment = {
  __typename?: 'AreasCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Area>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type AuditEvent = {
  __typename?: 'AuditEvent';
  changes?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  eventDate: Scalars['DateTime'];
  eventType?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  userName?: Maybe<Scalars['String']>;
};

export type AuditEventFilterInput = {
  and?: InputMaybe<Array<AuditEventFilterInput>>;
  changes?: InputMaybe<StringOperationFilterInput>;
  entityId?: InputMaybe<StringOperationFilterInput>;
  entityType?: InputMaybe<StringOperationFilterInput>;
  eventDate?: InputMaybe<DateTimeOperationFilterInput>;
  eventType?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<AuditEventFilterInput>>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type AuditEventSortInput = {
  changes?: InputMaybe<SortEnumType>;
  entityId?: InputMaybe<SortEnumType>;
  entityType?: InputMaybe<SortEnumType>;
  eventDate?: InputMaybe<SortEnumType>;
  eventType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AuditEventsCollectionSegment = {
  __typename?: 'AuditEventsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<AuditEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Bay = {
  __typename?: 'Bay';
  area?: Maybe<Area>;
  areaId: Scalars['UUID'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isOccupied: Scalars['Boolean'];
  isOverstay: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  pgsEnabled: Scalars['Boolean'];
  senseIqId: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
};

export type BayDto = {
  __typename?: 'BayDTO';
  area?: Maybe<AreaDto>;
  areaId: Scalars['UUID'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isOccupied: Scalars['Boolean'];
  isOverstay: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  pgsEnabled: Scalars['Boolean'];
  senseIqId: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
};

export type BayFilterInput = {
  and?: InputMaybe<Array<BayFilterInput>>;
  area?: InputMaybe<AreaFilterInput>;
  areaId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isOccupied?: InputMaybe<BooleanOperationFilterInput>;
  isOverstay?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BayFilterInput>>;
  pgsEnabled?: InputMaybe<BooleanOperationFilterInput>;
  senseIqId?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type BayInput = {
  area?: InputMaybe<AreaInput>;
  areaId: Scalars['UUID'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isOccupied: Scalars['Boolean'];
  isOverstay: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  pgsEnabled: Scalars['Boolean'];
  senseIqId: Scalars['Int'];
  type?: InputMaybe<Scalars['String']>;
};

export type BaySortInput = {
  area?: InputMaybe<AreaSortInput>;
  areaId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isOccupied?: InputMaybe<SortEnumType>;
  isOverstay?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
  pgsEnabled?: InputMaybe<SortEnumType>;
  senseIqId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BaysCollectionSegment = {
  __typename?: 'BaysCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Bay>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BehaviorViolation = {
  __typename?: 'BehaviorViolation';
  /**
   * For wrong bay violations, stores the area where the parker actually parked.
   * Used when applying area tariff adjustment on escalation.
   */
  actualAreaId?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  detectedUtc: Scalars['DateTime'];
  escalatedUtc?: Maybe<Scalars['DateTime']>;
  escalationNotes?: Maybe<Scalars['String']>;
  escalationScheduledUtc?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  parker?: Maybe<Parker>;
  parkerId?: Maybe<Scalars['UUID']>;
  resolutionMessage?: Maybe<Scalars['String']>;
  resolvedUtc?: Maybe<Scalars['DateTime']>;
  site?: Maybe<Site>;
  siteId: Scalars['UUID'];
  status: ViolationStatus;
  transaction?: Maybe<Transaction>;
  transactionId?: Maybe<Scalars['UUID']>;
  violationType: BehaviorViolationType;
};

export type BehaviorViolationFilterInput = {
  /**
   * For wrong bay violations, stores the area where the parker actually parked.
   * Used when applying area tariff adjustment on escalation.
   */
  actualAreaId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<BehaviorViolationFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  detectedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  escalatedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  escalationNotes?: InputMaybe<StringOperationFilterInput>;
  escalationScheduledUtc?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<BehaviorViolationFilterInput>>;
  parker?: InputMaybe<ParkerFilterInput>;
  parkerId?: InputMaybe<UuidOperationFilterInput>;
  resolutionMessage?: InputMaybe<StringOperationFilterInput>;
  resolvedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  status?: InputMaybe<ViolationStatusOperationFilterInput>;
  transaction?: InputMaybe<TransactionFilterInput>;
  transactionId?: InputMaybe<UuidOperationFilterInput>;
  violationType?: InputMaybe<BehaviorViolationTypeOperationFilterInput>;
};

export type BehaviorViolationInput = {
  /**
   * For wrong bay violations, stores the area where the parker actually parked.
   * Used when applying area tariff adjustment on escalation.
   */
  actualAreaId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  detectedUtc: Scalars['DateTime'];
  escalatedUtc?: InputMaybe<Scalars['DateTime']>;
  escalationNotes?: InputMaybe<Scalars['String']>;
  escalationScheduledUtc?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  parker?: InputMaybe<ParkerInput>;
  parkerId?: InputMaybe<Scalars['UUID']>;
  resolutionMessage?: InputMaybe<Scalars['String']>;
  resolvedUtc?: InputMaybe<Scalars['DateTime']>;
  site?: InputMaybe<SiteInput>;
  siteId: Scalars['UUID'];
  status: ViolationStatus;
  transaction?: InputMaybe<TransactionInput>;
  transactionId?: InputMaybe<Scalars['UUID']>;
  violationType: BehaviorViolationType;
};

export type BehaviorViolationSortInput = {
  /**
   * For wrong bay violations, stores the area where the parker actually parked.
   * Used when applying area tariff adjustment on escalation.
   */
  actualAreaId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  detectedUtc?: InputMaybe<SortEnumType>;
  escalatedUtc?: InputMaybe<SortEnumType>;
  escalationNotes?: InputMaybe<SortEnumType>;
  escalationScheduledUtc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  parker?: InputMaybe<ParkerSortInput>;
  parkerId?: InputMaybe<SortEnumType>;
  resolutionMessage?: InputMaybe<SortEnumType>;
  resolvedUtc?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  transaction?: InputMaybe<TransactionSortInput>;
  transactionId?: InputMaybe<SortEnumType>;
  violationType?: InputMaybe<SortEnumType>;
};

export enum BehaviorViolationType {
  NoValidPaymentMethod = 'NO_VALID_PAYMENT_METHOD',
  OutsideAllowedAccessHours = 'OUTSIDE_ALLOWED_ACCESS_HOURS',
  Overstay = 'OVERSTAY',
  ReEnteredWithoutExiting = 'RE_ENTERED_WITHOUT_EXITING',
  WrongBay = 'WRONG_BAY'
}

export type BehaviorViolationTypeOperationFilterInput = {
  eq?: InputMaybe<BehaviorViolationType>;
  in?: InputMaybe<Array<BehaviorViolationType>>;
  neq?: InputMaybe<BehaviorViolationType>;
  nin?: InputMaybe<Array<BehaviorViolationType>>;
};

/** A segment of a collection. */
export type BehaviorViolationsCollectionSegment = {
  __typename?: 'BehaviorViolationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<BehaviorViolation>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

/** A segment of a collection. */
export type CapacitiesCollectionSegment = {
  __typename?: 'CapacitiesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Capacity>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Capacity = {
  __typename?: 'Capacity';
  area?: Maybe<Area>;
  areaId?: Maybe<Scalars['UUID']>;
  dayOfWeek: Scalars['Int'];
  hour: Scalars['Int'];
  id: Scalars['UUID'];
  permanent: Scalars['Int'];
  public: Scalars['Int'];
  strata: Scalars['Int'];
  total: Scalars['Int'];
  visitor: Scalars['Int'];
};

export type CapacityDto = {
  __typename?: 'CapacityDTO';
  area?: Maybe<AreaDto>;
  areaId?: Maybe<Scalars['UUID']>;
  dayOfWeek: Scalars['Int'];
  hour: Scalars['Int'];
  id: Scalars['UUID'];
  permanent: Scalars['Int'];
  public: Scalars['Int'];
  strata: Scalars['Int'];
  total: Scalars['Int'];
  visitor: Scalars['Int'];
};

export type CapacityFilterInput = {
  and?: InputMaybe<Array<CapacityFilterInput>>;
  area?: InputMaybe<AreaFilterInput>;
  areaId?: InputMaybe<UuidOperationFilterInput>;
  dayOfWeek?: InputMaybe<IntOperationFilterInput>;
  hour?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<CapacityFilterInput>>;
  permanent?: InputMaybe<IntOperationFilterInput>;
  public?: InputMaybe<IntOperationFilterInput>;
  strata?: InputMaybe<IntOperationFilterInput>;
  total?: InputMaybe<IntOperationFilterInput>;
  visitor?: InputMaybe<IntOperationFilterInput>;
};

export type CapacityInput = {
  area?: InputMaybe<AreaInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek: Scalars['Int'];
  hour: Scalars['Int'];
  id: Scalars['UUID'];
  permanent: Scalars['Int'];
  public: Scalars['Int'];
  strata: Scalars['Int'];
  total: Scalars['Int'];
  visitor: Scalars['Int'];
};

export type CapacitySortInput = {
  area?: InputMaybe<AreaSortInput>;
  areaId?: InputMaybe<SortEnumType>;
  dayOfWeek?: InputMaybe<SortEnumType>;
  hour?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  permanent?: InputMaybe<SortEnumType>;
  public?: InputMaybe<SortEnumType>;
  strata?: InputMaybe<SortEnumType>;
  total?: InputMaybe<SortEnumType>;
  visitor?: InputMaybe<SortEnumType>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

/** A segment of a collection. */
export type CompaniesCollectionSegment = {
  __typename?: 'CompaniesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Company>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Company = {
  __typename?: 'Company';
  abn?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  addressMetadata?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  sites?: Maybe<Array<Maybe<Site>>>;
};

export type CompanyDto = {
  __typename?: 'CompanyDTO';
  abn?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  addressMetadata?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<PermissionDto>>>;
  sites?: Maybe<Array<Maybe<SiteDto>>>;
};

export type CompanyFilterInput = {
  abn?: InputMaybe<StringOperationFilterInput>;
  address?: InputMaybe<StringOperationFilterInput>;
  addressMetadata?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CompanyFilterInput>>;
  comments?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CompanyFilterInput>>;
  permissions?: InputMaybe<ListFilterInputTypeOfPermissionFilterInput>;
  sites?: InputMaybe<ListFilterInputTypeOfSiteFilterInput>;
};

export type CompanyInput = {
  abn?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  addressMetadata?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<PermissionInput>>>;
  sites?: InputMaybe<Array<InputMaybe<SiteInput>>>;
};

export type CompanySortInput = {
  abn?: InputMaybe<SortEnumType>;
  address?: InputMaybe<SortEnumType>;
  addressMetadata?: InputMaybe<SortEnumType>;
  comments?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DayOfWeekOperationFilterInput = {
  eq?: InputMaybe<DayOfWeek>;
  in?: InputMaybe<Array<DayOfWeek>>;
  neq?: InputMaybe<DayOfWeek>;
  nin?: InputMaybe<Array<DayOfWeek>>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
};

export type Event = {
  __typename?: 'Event';
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['UUID']>;
  transaction?: Maybe<Transaction>;
  transactionId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
};

export type EventDto = {
  __typename?: 'EventDTO';
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  site?: Maybe<SiteDto>;
  siteId?: Maybe<Scalars['UUID']>;
  transaction?: Maybe<TransactionDto>;
  transactionId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
};

export type EventFilterInput = {
  and?: InputMaybe<Array<EventFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  metadata?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EventFilterInput>>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  transaction?: InputMaybe<TransactionFilterInput>;
  transactionId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type EventInput = {
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  message?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['String']>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']>;
  transaction?: InputMaybe<TransactionInput>;
  transactionId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type EventSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
  metadata?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  transaction?: InputMaybe<TransactionSortInput>;
  transactionId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type EventsCollectionSegment = {
  __typename?: 'EventsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Event>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type HaveCapacityResult = {
  __typename?: 'HaveCapacityResult';
  error?: Maybe<Scalars['String']>;
  haveCapacity?: Maybe<Scalars['Boolean']>;
};

export type Identity = {
  __typename?: 'Identity';
  id: Scalars['UUID'];
  provider?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

export type IdentityDto = {
  __typename?: 'IdentityDTO';
  id: Scalars['UUID'];
  metadata?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  user?: Maybe<UserDto>;
  userId: Scalars['UUID'];
};

export type IdentityFilterInput = {
  and?: InputMaybe<Array<IdentityFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<IdentityFilterInput>>;
  provider?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type IdentityInput = {
  id: Scalars['UUID'];
  provider?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserInput>;
  userId: Scalars['UUID'];
};

export type Image = {
  __typename?: 'Image';
  accessLane?: Maybe<AccessLane>;
  accessLaneId?: Maybe<Scalars['UUID']>;
  bay?: Maybe<Bay>;
  bayId?: Maybe<Scalars['UUID']>;
  capturedUtc: Scalars['DateTime'];
  id: Scalars['UUID'];
  /**
   * Resolves the signed URL for the image using Azure Blob SAS token.
   * This overrides the ImageUrl property to return a time-limited signed URL.
   */
  imageUrl?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  siteId: Scalars['UUID'];
  siteMessage?: Maybe<SiteMessage>;
  siteMessageId: Scalars['Long'];
  url?: Maybe<Scalars['String']>;
};

export type ImageFilterInput = {
  accessLane?: InputMaybe<AccessLaneFilterInput>;
  accessLaneId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<ImageFilterInput>>;
  bay?: InputMaybe<BayFilterInput>;
  bayId?: InputMaybe<UuidOperationFilterInput>;
  capturedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ImageFilterInput>>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  siteMessage?: InputMaybe<SiteMessageFilterInput>;
  siteMessageId?: InputMaybe<LongOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type ImageInput = {
  accessLane?: InputMaybe<AccessLaneInput>;
  accessLaneId?: InputMaybe<Scalars['UUID']>;
  bay?: InputMaybe<BayInput>;
  bayId?: InputMaybe<Scalars['UUID']>;
  capturedUtc: Scalars['DateTime'];
  id: Scalars['UUID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<SiteInput>;
  siteId: Scalars['UUID'];
  siteMessage?: InputMaybe<SiteMessageInput>;
  siteMessageId: Scalars['Long'];
  url?: InputMaybe<Scalars['String']>;
};

export type ImageSortInput = {
  accessLane?: InputMaybe<AccessLaneSortInput>;
  accessLaneId?: InputMaybe<SortEnumType>;
  bay?: InputMaybe<BaySortInput>;
  bayId?: InputMaybe<SortEnumType>;
  capturedUtc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  imageUrl?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  siteMessage?: InputMaybe<SiteMessageSortInput>;
  siteMessageId?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ImagesCollectionSegment = {
  __typename?: 'ImagesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Image>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Decimal'];
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  id: Scalars['UUID'];
  invoiceItems?: Maybe<Array<Maybe<InvoiceItem>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  parker?: Maybe<Parker>;
  parkerId?: Maybe<Scalars['UUID']>;
  status?: Maybe<Scalars['String']>;
  stripeError?: Maybe<Scalars['String']>;
  stripeErrorUtc?: Maybe<Scalars['DateTime']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeInvoiceNumber?: Maybe<Scalars['String']>;
  stripeInvoicePdfUrl?: Maybe<Scalars['String']>;
  transaction?: Maybe<Transaction>;
  transactionId: Scalars['UUID'];
};

export type InvoiceDto = {
  __typename?: 'InvoiceDTO';
  amount: Scalars['Decimal'];
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  id: Scalars['UUID'];
  invoiceItems?: Maybe<Array<Maybe<InvoiceItemDto>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  parker?: Maybe<ParkerDto>;
  parkerId?: Maybe<Scalars['UUID']>;
  status?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeInvoiceNumber?: Maybe<Scalars['String']>;
  stripeInvoicePdfUrl?: Maybe<Scalars['String']>;
  transaction?: Maybe<TransactionDto>;
  transactionId: Scalars['UUID'];
};

export type InvoiceFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<InvoiceFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  invoiceItems?: InputMaybe<ListFilterInputTypeOfInvoiceItemFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InvoiceFilterInput>>;
  parker?: InputMaybe<ParkerFilterInput>;
  parkerId?: InputMaybe<UuidOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  stripeError?: InputMaybe<StringOperationFilterInput>;
  stripeErrorUtc?: InputMaybe<DateTimeOperationFilterInput>;
  stripeInvoiceId?: InputMaybe<StringOperationFilterInput>;
  stripeInvoiceNumber?: InputMaybe<StringOperationFilterInput>;
  stripeInvoicePdfUrl?: InputMaybe<StringOperationFilterInput>;
  transaction?: InputMaybe<TransactionFilterInput>;
  transactionId?: InputMaybe<UuidOperationFilterInput>;
};

export type InvoiceInput = {
  amount: Scalars['Decimal'];
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  id: Scalars['UUID'];
  invoiceItems?: InputMaybe<Array<InputMaybe<InvoiceItemInput>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  number?: InputMaybe<Scalars['String']>;
  parker?: InputMaybe<ParkerInput>;
  parkerId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  stripeError?: InputMaybe<Scalars['String']>;
  stripeErrorUtc?: InputMaybe<Scalars['DateTime']>;
  stripeInvoiceId?: InputMaybe<Scalars['String']>;
  stripeInvoiceNumber?: InputMaybe<Scalars['String']>;
  stripeInvoicePdfUrl?: InputMaybe<Scalars['String']>;
  transaction?: InputMaybe<TransactionInput>;
  transactionId: Scalars['UUID'];
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  amount: Scalars['Decimal'];
  createdDate: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  invoice?: Maybe<Invoice>;
  invoiceId?: Maybe<Scalars['UUID']>;
  quantity: Scalars['Int'];
  stripeId?: Maybe<Scalars['String']>;
  unitPrice: Scalars['Decimal'];
};

export type InvoiceItemDto = {
  __typename?: 'InvoiceItemDTO';
  amount: Scalars['Decimal'];
  createdDate: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  invoice?: Maybe<InvoiceDto>;
  invoiceId?: Maybe<Scalars['UUID']>;
  quantity: Scalars['Int'];
  stripeId?: Maybe<Scalars['String']>;
  unitPrice: Scalars['Decimal'];
};

export type InvoiceItemFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<InvoiceItemFilterInput>>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  invoice?: InputMaybe<InvoiceFilterInput>;
  invoiceId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<InvoiceItemFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  stripeId?: InputMaybe<StringOperationFilterInput>;
  unitPrice?: InputMaybe<DecimalOperationFilterInput>;
};

export type InvoiceItemInput = {
  amount: Scalars['Decimal'];
  createdDate: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  invoice?: InputMaybe<InvoiceInput>;
  invoiceId?: InputMaybe<Scalars['UUID']>;
  quantity: Scalars['Int'];
  stripeId?: InputMaybe<Scalars['String']>;
  unitPrice: Scalars['Decimal'];
};

export type InvoiceSortInput = {
  amount?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
  parker?: InputMaybe<ParkerSortInput>;
  parkerId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  stripeError?: InputMaybe<SortEnumType>;
  stripeErrorUtc?: InputMaybe<SortEnumType>;
  stripeInvoiceId?: InputMaybe<SortEnumType>;
  stripeInvoiceNumber?: InputMaybe<SortEnumType>;
  stripeInvoicePdfUrl?: InputMaybe<SortEnumType>;
  transaction?: InputMaybe<TransactionSortInput>;
  transactionId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type InvoicesCollectionSegment = {
  __typename?: 'InvoicesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Invoice>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type ListFilterInputTypeOfAccessLaneFilterInput = {
  all?: InputMaybe<AccessLaneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AccessLaneFilterInput>;
  some?: InputMaybe<AccessLaneFilterInput>;
};

export type ListFilterInputTypeOfAccessTimeFilterInput = {
  all?: InputMaybe<AccessTimeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AccessTimeFilterInput>;
  some?: InputMaybe<AccessTimeFilterInput>;
};

export type ListFilterInputTypeOfAreaFilterInput = {
  all?: InputMaybe<AreaFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AreaFilterInput>;
  some?: InputMaybe<AreaFilterInput>;
};

export type ListFilterInputTypeOfBayFilterInput = {
  all?: InputMaybe<BayFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BayFilterInput>;
  some?: InputMaybe<BayFilterInput>;
};

export type ListFilterInputTypeOfBehaviorViolationFilterInput = {
  all?: InputMaybe<BehaviorViolationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BehaviorViolationFilterInput>;
  some?: InputMaybe<BehaviorViolationFilterInput>;
};

export type ListFilterInputTypeOfCapacityFilterInput = {
  all?: InputMaybe<CapacityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CapacityFilterInput>;
  some?: InputMaybe<CapacityFilterInput>;
};

export type ListFilterInputTypeOfEventFilterInput = {
  all?: InputMaybe<EventFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EventFilterInput>;
  some?: InputMaybe<EventFilterInput>;
};

export type ListFilterInputTypeOfIdentityFilterInput = {
  all?: InputMaybe<IdentityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<IdentityFilterInput>;
  some?: InputMaybe<IdentityFilterInput>;
};

export type ListFilterInputTypeOfImageFilterInput = {
  all?: InputMaybe<ImageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ImageFilterInput>;
  some?: InputMaybe<ImageFilterInput>;
};

export type ListFilterInputTypeOfInvoiceFilterInput = {
  all?: InputMaybe<InvoiceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<InvoiceFilterInput>;
  some?: InputMaybe<InvoiceFilterInput>;
};

export type ListFilterInputTypeOfInvoiceItemFilterInput = {
  all?: InputMaybe<InvoiceItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<InvoiceItemFilterInput>;
  some?: InputMaybe<InvoiceItemFilterInput>;
};

export type ListFilterInputTypeOfMessageFilterInput = {
  all?: InputMaybe<MessageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MessageFilterInput>;
  some?: InputMaybe<MessageFilterInput>;
};

export type ListFilterInputTypeOfPermissionFilterInput = {
  all?: InputMaybe<PermissionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PermissionFilterInput>;
  some?: InputMaybe<PermissionFilterInput>;
};

export type ListFilterInputTypeOfProductFilterInput = {
  all?: InputMaybe<ProductFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductFilterInput>;
  some?: InputMaybe<ProductFilterInput>;
};

export type ListFilterInputTypeOfProductTimeFilterInput = {
  all?: InputMaybe<ProductTimeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductTimeFilterInput>;
  some?: InputMaybe<ProductTimeFilterInput>;
};

export type ListFilterInputTypeOfReservationFilterInput = {
  all?: InputMaybe<ReservationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ReservationFilterInput>;
  some?: InputMaybe<ReservationFilterInput>;
};

export type ListFilterInputTypeOfSiteFilterInput = {
  all?: InputMaybe<SiteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SiteFilterInput>;
  some?: InputMaybe<SiteFilterInput>;
};

export type ListFilterInputTypeOfSiteMessageFilterInput = {
  all?: InputMaybe<SiteMessageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SiteMessageFilterInput>;
  some?: InputMaybe<SiteMessageFilterInput>;
};

export type ListFilterInputTypeOfSiteParkerFilterInput = {
  all?: InputMaybe<SiteParkerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SiteParkerFilterInput>;
  some?: InputMaybe<SiteParkerFilterInput>;
};

export type ListFilterInputTypeOfTariffFilterInput = {
  all?: InputMaybe<TariffFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TariffFilterInput>;
  some?: InputMaybe<TariffFilterInput>;
};

export type ListFilterInputTypeOfTransactionFilterInput = {
  all?: InputMaybe<TransactionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TransactionFilterInput>;
  some?: InputMaybe<TransactionFilterInput>;
};

export type ListFilterInputTypeOfVehicleFilterInput = {
  all?: InputMaybe<VehicleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<VehicleFilterInput>;
  some?: InputMaybe<VehicleFilterInput>;
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  neq?: InputMaybe<Scalars['Long']>;
  ngt?: InputMaybe<Scalars['Long']>;
  ngte?: InputMaybe<Scalars['Long']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  nlt?: InputMaybe<Scalars['Long']>;
  nlte?: InputMaybe<Scalars['Long']>;
};

export type Message = {
  __typename?: 'Message';
  content?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isSent: Scalars['Boolean'];
  messageType?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  parker?: Maybe<Parker>;
  parkerId?: Maybe<Scalars['UUID']>;
  recipient?: Maybe<Scalars['String']>;
  sentTime: Scalars['DateTime'];
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['UUID']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type MessageFilterInput = {
  and?: InputMaybe<Array<MessageFilterInput>>;
  content?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isSent?: InputMaybe<BooleanOperationFilterInput>;
  messageType?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<MessageFilterInput>>;
  parker?: InputMaybe<ParkerFilterInput>;
  parkerId?: InputMaybe<UuidOperationFilterInput>;
  recipient?: InputMaybe<StringOperationFilterInput>;
  sentTime?: InputMaybe<DateTimeOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type MessageInput = {
  content?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isSent: Scalars['Boolean'];
  messageType?: InputMaybe<Scalars['String']>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  parker?: InputMaybe<ParkerInput>;
  parkerId?: InputMaybe<Scalars['UUID']>;
  recipient?: InputMaybe<Scalars['String']>;
  sentTime: Scalars['DateTime'];
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type MessageSortInput = {
  content?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isSent?: InputMaybe<SortEnumType>;
  messageType?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  parker?: InputMaybe<ParkerSortInput>;
  parkerId?: InputMaybe<SortEnumType>;
  recipient?: InputMaybe<SortEnumType>;
  sentTime?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type MessagesCollectionSegment = {
  __typename?: 'MessagesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Message>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addPermanentParker?: Maybe<SiteParker>;
  clearSiteData?: Maybe<Site>;
  deletePermission: Scalars['Boolean'];
  refreshParkerStripeData?: Maybe<Parker>;
  reissueQrCode?: Maybe<Parker>;
  resetTransaction?: Maybe<Transaction>;
  retryStripeInvoice?: Maybe<Invoice>;
  sendMessage?: Maybe<SiteMessage>;
  terminateTransaction?: Maybe<Transaction>;
  triggerRefresh?: Maybe<SiteCommand>;
  updateAccessTimes?: Maybe<Array<Maybe<AccessTime>>>;
  updateBay?: Maybe<Bay>;
  updateCapacities?: Maybe<Array<Maybe<Capacity>>>;
  updateCompany?: Maybe<Company>;
  updateParker?: Maybe<Parker>;
  updatePermanentParker?: Maybe<SiteParker>;
  updatePermission?: Maybe<Permission>;
  updatePricePlan?: Maybe<PricePlan>;
  updateProduct?: Maybe<ProductDto>;
  updateReservation?: Maybe<Reservation>;
  updateSite?: Maybe<Site>;
  updateTariffs?: Maybe<Array<Maybe<Tariff>>>;
  updateUser?: Maybe<User>;
  updateVehicle?: Maybe<Vehicle>;
};


export type MutationAddPermanentParkerArgs = {
  canBook?: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  isStrata?: Scalars['Boolean'];
  siteId: Scalars['UUID'];
};


export type MutationClearSiteDataArgs = {
  siteId: Scalars['UUID'];
};


export type MutationDeletePermissionArgs = {
  id: Scalars['UUID'];
};


export type MutationRefreshParkerStripeDataArgs = {
  parkerId: Scalars['UUID'];
};


export type MutationReissueQrCodeArgs = {
  parker?: InputMaybe<ParkerInput>;
};


export type MutationResetTransactionArgs = {
  transactionId: Scalars['UUID'];
};


export type MutationRetryStripeInvoiceArgs = {
  invoiceId: Scalars['UUID'];
};


export type MutationSendMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
  siteId: Scalars['UUID'];
  type?: InputMaybe<Scalars['String']>;
};


export type MutationTerminateTransactionArgs = {
  transactionId: Scalars['UUID'];
};


export type MutationTriggerRefreshArgs = {
  siteId: Scalars['UUID'];
};


export type MutationUpdateAccessTimesArgs = {
  accessTimes?: InputMaybe<Array<InputMaybe<AccessTimeInput>>>;
};


export type MutationUpdateBayArgs = {
  bay?: InputMaybe<BayInput>;
};


export type MutationUpdateCapacitiesArgs = {
  capacities?: InputMaybe<Array<InputMaybe<CapacityInput>>>;
};


export type MutationUpdateCompanyArgs = {
  company?: InputMaybe<CompanyInput>;
};


export type MutationUpdateParkerArgs = {
  parker?: InputMaybe<ParkerInput>;
};


export type MutationUpdatePermanentParkerArgs = {
  siteParker?: InputMaybe<SiteParkerInput>;
};


export type MutationUpdatePermissionArgs = {
  permission?: InputMaybe<PermissionInput>;
};


export type MutationUpdatePricePlanArgs = {
  pricePlan?: InputMaybe<PricePlanInput>;
};


export type MutationUpdateProductArgs = {
  product?: InputMaybe<ProductInput>;
};


export type MutationUpdateReservationArgs = {
  reservation?: InputMaybe<ReservationInput>;
};


export type MutationUpdateSiteArgs = {
  site?: InputMaybe<SiteInput>;
};


export type MutationUpdateTariffsArgs = {
  tariffs?: InputMaybe<Array<InputMaybe<TariffInput>>>;
};


export type MutationUpdateUserArgs = {
  user?: InputMaybe<UserInput>;
};


export type MutationUpdateVehicleArgs = {
  vehicle?: InputMaybe<VehicleInput>;
};

export type Parker = {
  __typename?: 'Parker';
  accessTimes?: Maybe<Array<Maybe<AccessTime>>>;
  agreeTermsConditions?: Maybe<Scalars['DateTime']>;
  bayPreference?: Maybe<Scalars['String']>;
  behaviorViolations?: Maybe<Array<Maybe<BehaviorViolation>>>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firebaseUserId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  hasValidPaymentMethod: Scalars['Boolean'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isEmailVerified: Scalars['Boolean'];
  isProfileComplete?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<Message>>>;
  mobile?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  notificationType?: Maybe<Scalars['String']>;
  permitNumber?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  /**
   * Ensures QrCode is always fetched from the database when Parker is projected.
   * This is needed because Uid depends on QrCode.
   */
  qrCode?: Maybe<Scalars['UUID']>;
  reservations?: Maybe<Array<Maybe<Reservation>>>;
  siteParkers?: Maybe<Array<Maybe<SiteParker>>>;
  state?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  streetType?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeDefaultPaymentMethodId?: Maybe<Scalars['String']>;
  stripeMetadata?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  /** Resolves the Uid property by encoding the QrCode as a ShortGuid. */
  uid?: Maybe<Scalars['String']>;
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
};

export type ParkerDto = {
  __typename?: 'ParkerDTO';
  accessTimes?: Maybe<Array<Maybe<AccessTimeDto>>>;
  agreeTermsConditions?: Maybe<Scalars['DateTime']>;
  bayPreference?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firebaseUserId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  hasValidPaymentMethod: Scalars['Boolean'];
  id: Scalars['UUID'];
  invoices?: Maybe<Array<Maybe<InvoiceDto>>>;
  isActive: Scalars['Boolean'];
  isEmailVerified: Scalars['Boolean'];
  isProfileComplete?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  notificationType?: Maybe<Scalars['String']>;
  permitNumber?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  qrCode?: Maybe<Scalars['UUID']>;
  reservations?: Maybe<Array<Maybe<ReservationDto>>>;
  siteParkers?: Maybe<Array<Maybe<SiteParkerDto>>>;
  state?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  streetType?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMetadata?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Maybe<TransactionDto>>>;
  uid?: Maybe<Scalars['String']>;
  validationErrors?: Maybe<Array<Maybe<Scalars['String']>>>;
  vehicles?: Maybe<Array<Maybe<VehicleDto>>>;
};

export type ParkerFilterInput = {
  accessTimes?: InputMaybe<ListFilterInputTypeOfAccessTimeFilterInput>;
  agreeTermsConditions?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ParkerFilterInput>>;
  bayPreference?: InputMaybe<StringOperationFilterInput>;
  behaviorViolations?: InputMaybe<ListFilterInputTypeOfBehaviorViolationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firebaseUserId?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isEmailVerified?: InputMaybe<BooleanOperationFilterInput>;
  isProfileComplete?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  messages?: InputMaybe<ListFilterInputTypeOfMessageFilterInput>;
  mobile?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  notificationType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ParkerFilterInput>>;
  permitNumber?: InputMaybe<StringOperationFilterInput>;
  postcode?: InputMaybe<StringOperationFilterInput>;
  qrCode?: InputMaybe<UuidOperationFilterInput>;
  reservations?: InputMaybe<ListFilterInputTypeOfReservationFilterInput>;
  siteParkers?: InputMaybe<ListFilterInputTypeOfSiteParkerFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  streetName?: InputMaybe<StringOperationFilterInput>;
  streetNumber?: InputMaybe<StringOperationFilterInput>;
  streetType?: InputMaybe<StringOperationFilterInput>;
  stripeCustomerId?: InputMaybe<StringOperationFilterInput>;
  stripeDefaultPaymentMethodId?: InputMaybe<StringOperationFilterInput>;
  stripeMetadata?: InputMaybe<StringOperationFilterInput>;
  suburb?: InputMaybe<StringOperationFilterInput>;
  transactions?: InputMaybe<ListFilterInputTypeOfTransactionFilterInput>;
  uid?: InputMaybe<StringOperationFilterInput>;
  vehicles?: InputMaybe<ListFilterInputTypeOfVehicleFilterInput>;
};

export type ParkerInput = {
  accessTimes?: InputMaybe<Array<InputMaybe<AccessTimeInput>>>;
  agreeTermsConditions?: InputMaybe<Scalars['DateTime']>;
  bayPreference?: InputMaybe<Scalars['String']>;
  behaviorViolations?: InputMaybe<Array<InputMaybe<BehaviorViolationInput>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firebaseUserId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isEmailVerified: Scalars['Boolean'];
  isProfileComplete?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<MessageInput>>>;
  mobile?: InputMaybe<Scalars['String']>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  notificationType?: InputMaybe<Scalars['String']>;
  permitNumber?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  qrCode?: InputMaybe<Scalars['UUID']>;
  reservations?: InputMaybe<Array<InputMaybe<ReservationInput>>>;
  siteParkers?: InputMaybe<Array<InputMaybe<SiteParkerInput>>>;
  state?: InputMaybe<Scalars['String']>;
  streetName?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  streetType?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeDefaultPaymentMethodId?: InputMaybe<Scalars['String']>;
  stripeMetadata?: InputMaybe<Scalars['String']>;
  suburb?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<Array<InputMaybe<TransactionInput>>>;
  uid?: InputMaybe<Scalars['String']>;
  vehicles?: InputMaybe<Array<InputMaybe<VehicleInput>>>;
};

export type ParkerSortInput = {
  agreeTermsConditions?: InputMaybe<SortEnumType>;
  bayPreference?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firebaseUserId?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isEmailVerified?: InputMaybe<SortEnumType>;
  isProfileComplete?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  mobile?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  notificationType?: InputMaybe<SortEnumType>;
  permitNumber?: InputMaybe<SortEnumType>;
  postcode?: InputMaybe<SortEnumType>;
  qrCode?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  streetName?: InputMaybe<SortEnumType>;
  streetNumber?: InputMaybe<SortEnumType>;
  streetType?: InputMaybe<SortEnumType>;
  stripeCustomerId?: InputMaybe<SortEnumType>;
  stripeDefaultPaymentMethodId?: InputMaybe<SortEnumType>;
  stripeMetadata?: InputMaybe<SortEnumType>;
  suburb?: InputMaybe<SortEnumType>;
  uid?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ParkersCollectionSegment = {
  __typename?: 'ParkersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Parker>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Permission = {
  __typename?: 'Permission';
  area?: Maybe<Area>;
  areaId?: Maybe<Scalars['UUID']>;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['UUID']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type PermissionDto = {
  __typename?: 'PermissionDTO';
  area?: Maybe<AreaDto>;
  areaId?: Maybe<Scalars['UUID']>;
  company?: Maybe<CompanyDto>;
  companyId?: Maybe<Scalars['UUID']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  site?: Maybe<SiteDto>;
  siteId?: Maybe<Scalars['UUID']>;
  user?: Maybe<UserDto>;
  userId?: Maybe<Scalars['UUID']>;
};

export type PermissionFilterInput = {
  and?: InputMaybe<Array<PermissionFilterInput>>;
  area?: InputMaybe<AreaFilterInput>;
  areaId?: InputMaybe<UuidOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PermissionFilterInput>>;
  role?: InputMaybe<StringOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type PermissionInput = {
  area?: InputMaybe<AreaInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<CompanyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  role?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type PermissionSortInput = {
  area?: InputMaybe<AreaSortInput>;
  areaId?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PermissionsCollectionSegment = {
  __typename?: 'PermissionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Permission>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type PricePlan = {
  __typename?: 'PricePlan';
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  siteId: Scalars['UUID'];
  startDate: Scalars['DateTime'];
  tariffs?: Maybe<Array<Maybe<Tariff>>>;
};

export type PricePlanFilterInput = {
  and?: InputMaybe<Array<PricePlanFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PricePlanFilterInput>>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  tariffs?: InputMaybe<ListFilterInputTypeOfTariffFilterInput>;
};

export type PricePlanInput = {
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<SiteInput>;
  siteId: Scalars['UUID'];
  startDate: Scalars['DateTime'];
  tariffs?: InputMaybe<Array<InputMaybe<TariffInput>>>;
};

export type PricePlanSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PricePlansCollectionSegment = {
  __typename?: 'PricePlansCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<PricePlan>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Product = {
  __typename?: 'Product';
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  maxPricePerDay?: Maybe<Scalars['Decimal']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  mustArriveAfter?: Maybe<Scalars['Int']>;
  mustArriveBefore?: Maybe<Scalars['Int']>;
  mustDepartAfter?: Maybe<Scalars['Int']>;
  mustDepartBefore?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pricePerHour?: Maybe<Scalars['Decimal']>;
  productTimes?: Maybe<Array<Maybe<ProductTime>>>;
  productTimesJson?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  siteId: Scalars['UUID'];
};

export type ProductDto = {
  __typename?: 'ProductDTO';
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  maxPricePerDay?: Maybe<Scalars['Decimal']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  mustArriveAfter?: Maybe<Scalars['Int']>;
  mustArriveBefore?: Maybe<Scalars['Int']>;
  mustDepartAfter?: Maybe<Scalars['Int']>;
  mustDepartBefore?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pricePerHour?: Maybe<Scalars['Decimal']>;
  productTimes?: Maybe<Array<Maybe<ProductTime>>>;
  productTimesJson?: Maybe<Scalars['String']>;
  site?: Maybe<SiteDto>;
  siteId: Scalars['UUID'];
};

export type ProductFilterInput = {
  and?: InputMaybe<Array<ProductFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  maxPricePerDay?: InputMaybe<DecimalOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  mustArriveAfter?: InputMaybe<IntOperationFilterInput>;
  mustArriveBefore?: InputMaybe<IntOperationFilterInput>;
  mustDepartAfter?: InputMaybe<IntOperationFilterInput>;
  mustDepartBefore?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductFilterInput>>;
  pricePerHour?: InputMaybe<DecimalOperationFilterInput>;
  productTimes?: InputMaybe<ListFilterInputTypeOfProductTimeFilterInput>;
  productTimesJson?: InputMaybe<StringOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
};

export type ProductInput = {
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  maxPricePerDay?: InputMaybe<Scalars['Decimal']>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  mustArriveAfter?: InputMaybe<Scalars['Int']>;
  mustArriveBefore?: InputMaybe<Scalars['Int']>;
  mustDepartAfter?: InputMaybe<Scalars['Int']>;
  mustDepartBefore?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  pricePerHour?: InputMaybe<Scalars['Decimal']>;
  productTimes?: InputMaybe<Array<InputMaybe<ProductTimeInput>>>;
  productTimesJson?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<SiteInput>;
  siteId: Scalars['UUID'];
};

export type ProductSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  maxPricePerDay?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  mustArriveAfter?: InputMaybe<SortEnumType>;
  mustArriveBefore?: InputMaybe<SortEnumType>;
  mustDepartAfter?: InputMaybe<SortEnumType>;
  mustDepartBefore?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pricePerHour?: InputMaybe<SortEnumType>;
  productTimesJson?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
};

export type ProductTime = {
  __typename?: 'ProductTime';
  dayOfWeek: Scalars['Int'];
  hour: Scalars['Int'];
};

export type ProductTimeFilterInput = {
  and?: InputMaybe<Array<ProductTimeFilterInput>>;
  dayOfWeek?: InputMaybe<IntOperationFilterInput>;
  hour?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductTimeFilterInput>>;
};

export type ProductTimeInput = {
  dayOfWeek: Scalars['Int'];
  hour: Scalars['Int'];
};

/** A segment of a collection. */
export type ProductsCollectionSegment = {
  __typename?: 'ProductsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Product>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  accessLanes?: Maybe<AccessLanesCollectionSegment>;
  accessTimes?: Maybe<AccessTimesCollectionSegment>;
  areas?: Maybe<AreasCollectionSegment>;
  auditEvents?: Maybe<AuditEventsCollectionSegment>;
  bays?: Maybe<BaysCollectionSegment>;
  behaviorViolations?: Maybe<BehaviorViolationsCollectionSegment>;
  capacities?: Maybe<CapacitiesCollectionSegment>;
  companies?: Maybe<CompaniesCollectionSegment>;
  events?: Maybe<EventsCollectionSegment>;
  haveCapacity?: Maybe<HaveCapacityResult>;
  images?: Maybe<ImagesCollectionSegment>;
  invoices?: Maybe<InvoicesCollectionSegment>;
  me?: Maybe<UserDto>;
  messages?: Maybe<MessagesCollectionSegment>;
  /** Returns the current user's permissions. Used by the frontend to determine what permissions the user can grant. */
  myPermissions?: Maybe<Array<Maybe<Permission>>>;
  parkers?: Maybe<ParkersCollectionSegment>;
  permissions?: Maybe<PermissionsCollectionSegment>;
  pricePlans?: Maybe<PricePlansCollectionSegment>;
  products?: Maybe<ProductsCollectionSegment>;
  reservations?: Maybe<ReservationsCollectionSegment>;
  siteCommands?: Maybe<SiteCommandsCollectionSegment>;
  siteConnectionEvents?: Maybe<SiteConnectionEventsCollectionSegment>;
  siteMessages?: Maybe<SiteMessagesCollectionSegment>;
  siteParkers?: Maybe<SiteParkersCollectionSegment>;
  sitePermissions?: Maybe<SitePermissionsCollectionSegment>;
  sites?: Maybe<SitesCollectionSegment>;
  statuses?: Maybe<StatusesCollectionSegment>;
  tariffs?: Maybe<TariffsCollectionSegment>;
  testProduct?: Maybe<ReservationDto>;
  timeZones?: Maybe<Array<Maybe<Scalars['String']>>>;
  transactionById?: Maybe<Transaction>;
  transactions?: Maybe<TransactionsCollectionSegment>;
  users?: Maybe<UsersCollectionSegment>;
  vehicles?: Maybe<VehiclesCollectionSegment>;
};


export type QueryAccessLanesArgs = {
  order?: InputMaybe<Array<AccessLaneSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessLaneFilterInput>;
};


export type QueryAccessTimesArgs = {
  order?: InputMaybe<Array<AccessTimeSortInput>>;
  siteParkerId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessTimeFilterInput>;
};


export type QueryAreasArgs = {
  order?: InputMaybe<Array<AreaSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AreaFilterInput>;
};


export type QueryAuditEventsArgs = {
  order?: InputMaybe<Array<AuditEventSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditEventFilterInput>;
};


export type QueryBaysArgs = {
  order?: InputMaybe<Array<BaySortInput>>;
  siteId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BayFilterInput>;
};


export type QueryBehaviorViolationsArgs = {
  order?: InputMaybe<Array<BehaviorViolationSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BehaviorViolationFilterInput>;
};


export type QueryCapacitiesArgs = {
  order?: InputMaybe<Array<CapacitySortInput>>;
  siteId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CapacityFilterInput>;
};


export type QueryCompaniesArgs = {
  order?: InputMaybe<Array<CompanySortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CompanyFilterInput>;
};


export type QueryEventsArgs = {
  order?: InputMaybe<Array<EventSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventFilterInput>;
};


export type QueryHaveCapacityArgs = {
  areaId?: InputMaybe<Scalars['UUID']>;
  end?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['UUID']>;
  siteId: Scalars['UUID'];
  start?: InputMaybe<Scalars['String']>;
};


export type QueryImagesArgs = {
  order?: InputMaybe<Array<ImageSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ImageFilterInput>;
};


export type QueryInvoicesArgs = {
  order?: InputMaybe<Array<InvoiceSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InvoiceFilterInput>;
};


export type QueryMessagesArgs = {
  order?: InputMaybe<Array<MessageSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MessageFilterInput>;
};


export type QueryParkersArgs = {
  order?: InputMaybe<Array<ParkerSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ParkerFilterInput>;
};


export type QueryPermissionsArgs = {
  order?: InputMaybe<Array<PermissionSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PermissionFilterInput>;
};


export type QueryPricePlansArgs = {
  order?: InputMaybe<Array<PricePlanSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PricePlanFilterInput>;
};


export type QueryProductsArgs = {
  order?: InputMaybe<Array<ProductSortInput>>;
  siteId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductFilterInput>;
};


export type QueryReservationsArgs = {
  order?: InputMaybe<Array<ReservationSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReservationFilterInput>;
};


export type QuerySiteCommandsArgs = {
  order?: InputMaybe<Array<SiteCommandSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SiteCommandFilterInput>;
};


export type QuerySiteConnectionEventsArgs = {
  order?: InputMaybe<Array<SiteConnectionEventSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SiteConnectionEventFilterInput>;
};


export type QuerySiteMessagesArgs = {
  order?: InputMaybe<Array<SiteMessageSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SiteMessageFilterInput>;
};


export type QuerySiteParkersArgs = {
  order?: InputMaybe<Array<SiteParkerSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SiteParkerFilterInput>;
};


export type QuerySitePermissionsArgs = {
  order?: InputMaybe<Array<PermissionSortInput>>;
  siteId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PermissionFilterInput>;
};


export type QuerySitesArgs = {
  order?: InputMaybe<Array<SiteSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SiteFilterInput>;
};


export type QueryStatusesArgs = {
  order?: InputMaybe<Array<StatusSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StatusFilterInput>;
};


export type QueryTariffsArgs = {
  order?: InputMaybe<Array<TariffSortInput>>;
  siteId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TariffFilterInput>;
};


export type QueryTransactionByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryTransactionsArgs = {
  order?: InputMaybe<Array<TransactionSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionFilterInput>;
};


export type QueryUsersArgs = {
  order?: InputMaybe<Array<UserSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserFilterInput>;
};


export type QueryVehiclesArgs = {
  order?: InputMaybe<Array<VehicleSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VehicleFilterInput>;
};

export type Reservation = {
  __typename?: 'Reservation';
  area?: Maybe<Area>;
  areaId?: Maybe<Scalars['UUID']>;
  bay?: Maybe<Bay>;
  bayId?: Maybe<Scalars['UUID']>;
  bayType?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  endUtc?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isPermanentParker: Scalars['Boolean'];
  mobile?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  parker?: Maybe<Parker>;
  parkerId?: Maybe<Scalars['UUID']>;
  plate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Decimal']>;
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['UUID']>;
  /** @deprecated The Source property is deprecated. Use the SourceType property instead. */
  source?: Maybe<Scalars['String']>;
  sourceType: ReservationSource;
  startDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  startUtc?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  uid?: Maybe<Scalars['String']>;
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars['UUID']>;
  visitorName?: Maybe<Scalars['String']>;
  visitorPhone?: Maybe<Scalars['String']>;
};

export type ReservationDto = {
  __typename?: 'ReservationDTO';
  area?: Maybe<AreaDto>;
  areaId?: Maybe<Scalars['UUID']>;
  bay?: Maybe<BayDto>;
  bayId?: Maybe<Scalars['UUID']>;
  bayType?: Maybe<Scalars['String']>;
  bookingFor?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  endUtc?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  invoiceItems?: Maybe<Array<Maybe<InvoiceItemDto>>>;
  isActive: Scalars['Boolean'];
  isPermanentParker: Scalars['Boolean'];
  mobile?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  parker?: Maybe<ParkerDto>;
  parkerId?: Maybe<Scalars['UUID']>;
  plate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Decimal']>;
  products?: Maybe<Array<Maybe<ProductDto>>>;
  site?: Maybe<SiteDto>;
  siteId?: Maybe<Scalars['UUID']>;
  /** @deprecated The Source property is deprecated. Use the SourceType property instead. */
  source?: Maybe<Scalars['String']>;
  sourceType?: Maybe<ReservationSource>;
  startDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  startUtc?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Maybe<TransactionDto>>>;
  uid?: Maybe<Scalars['String']>;
  vehicle?: Maybe<VehicleDto>;
  vehicleId?: Maybe<Scalars['UUID']>;
};

export type ReservationFilterInput = {
  and?: InputMaybe<Array<ReservationFilterInput>>;
  area?: InputMaybe<AreaFilterInput>;
  areaId?: InputMaybe<UuidOperationFilterInput>;
  bay?: InputMaybe<BayFilterInput>;
  bayId?: InputMaybe<UuidOperationFilterInput>;
  bayType?: InputMaybe<StringOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<StringOperationFilterInput>;
  endTime?: InputMaybe<StringOperationFilterInput>;
  endUtc?: InputMaybe<DateTimeOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isPermanentParker?: InputMaybe<BooleanOperationFilterInput>;
  mobile?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReservationFilterInput>>;
  parker?: InputMaybe<ParkerFilterInput>;
  parkerId?: InputMaybe<UuidOperationFilterInput>;
  plate?: InputMaybe<StringOperationFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  source?: InputMaybe<StringOperationFilterInput>;
  sourceType?: InputMaybe<ReservationSourceOperationFilterInput>;
  startDate?: InputMaybe<StringOperationFilterInput>;
  startTime?: InputMaybe<StringOperationFilterInput>;
  startUtc?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  transactions?: InputMaybe<ListFilterInputTypeOfTransactionFilterInput>;
  uid?: InputMaybe<StringOperationFilterInput>;
  vehicle?: InputMaybe<VehicleFilterInput>;
  vehicleId?: InputMaybe<UuidOperationFilterInput>;
  visitorName?: InputMaybe<StringOperationFilterInput>;
  visitorPhone?: InputMaybe<StringOperationFilterInput>;
};

export type ReservationInput = {
  area?: InputMaybe<AreaInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  bay?: InputMaybe<BayInput>;
  bayId?: InputMaybe<Scalars['UUID']>;
  bayType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  endUtc?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isPermanentParker: Scalars['Boolean'];
  mobile?: InputMaybe<Scalars['String']>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  parker?: InputMaybe<ParkerInput>;
  parkerId?: InputMaybe<Scalars['UUID']>;
  plate?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Decimal']>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']>;
  /** @deprecated The Source property is deprecated. Use the SourceType property instead. */
  source?: InputMaybe<Scalars['String']>;
  sourceType: ReservationSource;
  startDate?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  startUtc?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<Array<InputMaybe<TransactionInput>>>;
  uid?: InputMaybe<Scalars['String']>;
  vehicle?: InputMaybe<VehicleInput>;
  vehicleId?: InputMaybe<Scalars['UUID']>;
  visitorName?: InputMaybe<Scalars['String']>;
  visitorPhone?: InputMaybe<Scalars['String']>;
};

export type ReservationSortInput = {
  area?: InputMaybe<AreaSortInput>;
  areaId?: InputMaybe<SortEnumType>;
  bay?: InputMaybe<BaySortInput>;
  bayId?: InputMaybe<SortEnumType>;
  bayType?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  endTime?: InputMaybe<SortEnumType>;
  endUtc?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isPermanentParker?: InputMaybe<SortEnumType>;
  mobile?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parker?: InputMaybe<ParkerSortInput>;
  parkerId?: InputMaybe<SortEnumType>;
  plate?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  sourceType?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  startTime?: InputMaybe<SortEnumType>;
  startUtc?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  uid?: InputMaybe<SortEnumType>;
  vehicle?: InputMaybe<VehicleSortInput>;
  vehicleId?: InputMaybe<SortEnumType>;
  visitorName?: InputMaybe<SortEnumType>;
  visitorPhone?: InputMaybe<SortEnumType>;
};

export enum ReservationSource {
  Admin = 'ADMIN',
  Public = 'PUBLIC',
  Strata = 'STRATA'
}

export type ReservationSourceOperationFilterInput = {
  eq?: InputMaybe<ReservationSource>;
  in?: InputMaybe<Array<ReservationSource>>;
  neq?: InputMaybe<ReservationSource>;
  nin?: InputMaybe<Array<ReservationSource>>;
};

/** A segment of a collection. */
export type ReservationsCollectionSegment = {
  __typename?: 'ReservationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Reservation>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Site = {
  __typename?: 'Site';
  accessLanes?: Maybe<Array<Maybe<AccessLane>>>;
  accessTimes?: Maybe<Array<Maybe<AccessTime>>>;
  address?: Maybe<Scalars['String']>;
  addressMetadata?: Maybe<Scalars['String']>;
  apiKey?: Maybe<Scalars['String']>;
  areas?: Maybe<Array<Maybe<Area>>>;
  bayTypes?: Maybe<Scalars['String']>;
  behaviorViolations?: Maybe<Array<Maybe<BehaviorViolation>>>;
  behaviourConfig?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  connectionId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  daysToStoreMessages: Scalars['Int'];
  events?: Maybe<Array<Maybe<Event>>>;
  gracePeriod: Scalars['Int'];
  id: Scalars['UUID'];
  immediateNotifications: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  isListed: Scalars['Boolean'];
  lgaName?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  notificationEmails?: Maybe<Scalars['String']>;
  notificationPhones?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  products?: Maybe<Array<Maybe<Product>>>;
  reservationBuffer: Scalars['Int'];
  siteMessages?: Maybe<Array<Maybe<SiteMessage>>>;
  siteParkers?: Maybe<Array<Maybe<SiteParker>>>;
  tariff?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  welcomeMessage?: Maybe<Scalars['String']>;
};

/** Commands are messages that go TO a specific senseIQ */
export type SiteCommand = {
  __typename?: 'SiteCommand';
  createdUtc: Scalars['DateTime'];
  id: Scalars['Long'];
  payload?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  siteId: Scalars['UUID'];
  type?: Maybe<Scalars['String']>;
};

/** Commands are messages that go TO a specific senseIQ */
export type SiteCommandFilterInput = {
  and?: InputMaybe<Array<SiteCommandFilterInput>>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<SiteCommandFilterInput>>;
  payload?: InputMaybe<StringOperationFilterInput>;
  response?: InputMaybe<StringOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

/** Commands are messages that go TO a specific senseIQ */
export type SiteCommandSortInput = {
  createdUtc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  payload?: InputMaybe<SortEnumType>;
  response?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SiteCommandsCollectionSegment = {
  __typename?: 'SiteCommandsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<SiteCommand>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type SiteConnectionEvent = {
  __typename?: 'SiteConnectionEvent';
  connectionId?: Maybe<Scalars['String']>;
  createdUtc: Scalars['DateTime'];
  disconnectReason?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  ipAddress?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  siteId: Scalars['UUID'];
};

export type SiteConnectionEventFilterInput = {
  and?: InputMaybe<Array<SiteConnectionEventFilterInput>>;
  connectionId?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  disconnectReason?: InputMaybe<StringOperationFilterInput>;
  eventType?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  ipAddress?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteConnectionEventFilterInput>>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
};

export type SiteConnectionEventSortInput = {
  connectionId?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  disconnectReason?: InputMaybe<SortEnumType>;
  eventType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  ipAddress?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SiteConnectionEventsCollectionSegment = {
  __typename?: 'SiteConnectionEventsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<SiteConnectionEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type SiteDto = {
  __typename?: 'SiteDTO';
  accessLanes?: Maybe<Array<Maybe<AccessLaneDto>>>;
  accessTimes?: Maybe<Array<Maybe<AccessTimeDto>>>;
  address?: Maybe<Scalars['String']>;
  addressMetadata?: Maybe<Scalars['String']>;
  apiKey?: Maybe<Scalars['String']>;
  areas?: Maybe<Array<Maybe<AreaDto>>>;
  bayTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  behaviourConfig?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyDto>;
  companyId: Scalars['UUID'];
  connectionId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  currentCapacity?: Maybe<Scalars['Int']>;
  daysToStoreMessages: Scalars['Int'];
  events?: Maybe<Array<Maybe<EventDto>>>;
  gracePeriod: Scalars['Int'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isListed: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  lgaName?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<PermissionDto>>>;
  products?: Maybe<Array<Maybe<ProductDto>>>;
  reservationBuffer: Scalars['Int'];
  siteMessages?: Maybe<Array<Maybe<SiteMessageDto>>>;
  siteParkers?: Maybe<Array<Maybe<SiteParkerDto>>>;
  timeZone?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Maybe<TransactionDto>>>;
  welcomeMessage?: Maybe<Scalars['String']>;
};

export type SiteFilterInput = {
  accessLanes?: InputMaybe<ListFilterInputTypeOfAccessLaneFilterInput>;
  accessTimes?: InputMaybe<ListFilterInputTypeOfAccessTimeFilterInput>;
  address?: InputMaybe<StringOperationFilterInput>;
  addressMetadata?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<SiteFilterInput>>;
  apiKey?: InputMaybe<StringOperationFilterInput>;
  areas?: InputMaybe<ListFilterInputTypeOfAreaFilterInput>;
  bayTypes?: InputMaybe<StringOperationFilterInput>;
  behaviorViolations?: InputMaybe<ListFilterInputTypeOfBehaviorViolationFilterInput>;
  behaviourConfig?: InputMaybe<StringOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  connectionId?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  daysToStoreMessages?: InputMaybe<IntOperationFilterInput>;
  events?: InputMaybe<ListFilterInputTypeOfEventFilterInput>;
  gracePeriod?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  immediateNotifications?: InputMaybe<BooleanOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isListed?: InputMaybe<BooleanOperationFilterInput>;
  lgaName?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notificationEmails?: InputMaybe<StringOperationFilterInput>;
  notificationPhones?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteFilterInput>>;
  permissions?: InputMaybe<ListFilterInputTypeOfPermissionFilterInput>;
  products?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  reservationBuffer?: InputMaybe<IntOperationFilterInput>;
  siteMessages?: InputMaybe<ListFilterInputTypeOfSiteMessageFilterInput>;
  siteParkers?: InputMaybe<ListFilterInputTypeOfSiteParkerFilterInput>;
  tariff?: InputMaybe<StringOperationFilterInput>;
  timeZone?: InputMaybe<StringOperationFilterInput>;
  token?: InputMaybe<StringOperationFilterInput>;
  transactions?: InputMaybe<ListFilterInputTypeOfTransactionFilterInput>;
  welcomeMessage?: InputMaybe<StringOperationFilterInput>;
};

export type SiteInput = {
  accessLanes?: InputMaybe<Array<InputMaybe<AccessLaneInput>>>;
  accessTimes?: InputMaybe<Array<InputMaybe<AccessTimeInput>>>;
  address?: InputMaybe<Scalars['String']>;
  addressMetadata?: InputMaybe<Scalars['String']>;
  apiKey?: InputMaybe<Scalars['String']>;
  areas?: InputMaybe<Array<InputMaybe<AreaInput>>>;
  bayTypes?: InputMaybe<Scalars['String']>;
  behaviorViolations?: InputMaybe<Array<InputMaybe<BehaviorViolationInput>>>;
  behaviourConfig?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompanyInput>;
  companyId: Scalars['UUID'];
  connectionId?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  daysToStoreMessages: Scalars['Int'];
  events?: InputMaybe<Array<InputMaybe<EventInput>>>;
  gracePeriod: Scalars['Int'];
  id: Scalars['UUID'];
  immediateNotifications: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  isListed: Scalars['Boolean'];
  lgaName?: InputMaybe<Scalars['String']>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmails?: InputMaybe<Scalars['String']>;
  notificationPhones?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<PermissionInput>>>;
  products?: InputMaybe<Array<InputMaybe<ProductInput>>>;
  reservationBuffer: Scalars['Int'];
  siteMessages?: InputMaybe<Array<InputMaybe<SiteMessageInput>>>;
  siteParkers?: InputMaybe<Array<InputMaybe<SiteParkerInput>>>;
  tariff?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<Array<InputMaybe<TransactionInput>>>;
  welcomeMessage?: InputMaybe<Scalars['String']>;
};

export type SiteMessage = {
  __typename?: 'SiteMessage';
  createdUtc: Scalars['DateTime'];
  duration: Scalars['Long'];
  id: Scalars['Long'];
  images?: Maybe<Array<Maybe<Image>>>;
  payload?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  sequenceId: Scalars['Long'];
  site?: Maybe<Site>;
  siteId: Scalars['UUID'];
  transaction?: Maybe<Transaction>;
  transactionId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
};

export type SiteMessageDto = {
  __typename?: 'SiteMessageDTO';
  createdUtc: Scalars['DateTime'];
  duration: Scalars['Long'];
  id: Scalars['Long'];
  payload?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  sequenceId: Scalars['Long'];
  site?: Maybe<SiteDto>;
  siteId: Scalars['UUID'];
  transaction?: Maybe<TransactionDto>;
  transactionId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
};

export type SiteMessageFilterInput = {
  and?: InputMaybe<Array<SiteMessageFilterInput>>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  duration?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  images?: InputMaybe<ListFilterInputTypeOfImageFilterInput>;
  or?: InputMaybe<Array<SiteMessageFilterInput>>;
  payload?: InputMaybe<StringOperationFilterInput>;
  response?: InputMaybe<StringOperationFilterInput>;
  sequenceId?: InputMaybe<LongOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  transaction?: InputMaybe<TransactionFilterInput>;
  transactionId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type SiteMessageInput = {
  createdUtc: Scalars['DateTime'];
  duration: Scalars['Long'];
  id: Scalars['Long'];
  images?: InputMaybe<Array<InputMaybe<ImageInput>>>;
  payload?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Scalars['String']>;
  sequenceId: Scalars['Long'];
  site?: InputMaybe<SiteInput>;
  siteId: Scalars['UUID'];
  transaction?: InputMaybe<TransactionInput>;
  transactionId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type SiteMessageSortInput = {
  createdUtc?: InputMaybe<SortEnumType>;
  duration?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  payload?: InputMaybe<SortEnumType>;
  response?: InputMaybe<SortEnumType>;
  sequenceId?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  transaction?: InputMaybe<TransactionSortInput>;
  transactionId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SiteMessagesCollectionSegment = {
  __typename?: 'SiteMessagesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<SiteMessage>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type SiteParker = {
  __typename?: 'SiteParker';
  accessTimes?: Maybe<Array<Maybe<AccessTime>>>;
  area?: Maybe<Area>;
  areaId?: Maybe<Scalars['UUID']>;
  canBook: Scalars['Boolean'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isStrata: Scalars['Boolean'];
  parker?: Maybe<Parker>;
  parkerId: Scalars['UUID'];
  publicDescription?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  siteId: Scalars['UUID'];
};

export type SiteParkerDto = {
  __typename?: 'SiteParkerDTO';
  accessTimes?: Maybe<Array<Maybe<AccessTimeDto>>>;
  area?: Maybe<AreaDto>;
  areaId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  parker?: Maybe<ParkerDto>;
  parkerId: Scalars['UUID'];
  publicDescription?: Maybe<Scalars['String']>;
  site?: Maybe<SiteDto>;
  siteId: Scalars['UUID'];
};

export type SiteParkerFilterInput = {
  accessTimes?: InputMaybe<ListFilterInputTypeOfAccessTimeFilterInput>;
  and?: InputMaybe<Array<SiteParkerFilterInput>>;
  area?: InputMaybe<AreaFilterInput>;
  areaId?: InputMaybe<UuidOperationFilterInput>;
  canBook?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isStrata?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<SiteParkerFilterInput>>;
  parker?: InputMaybe<ParkerFilterInput>;
  parkerId?: InputMaybe<UuidOperationFilterInput>;
  publicDescription?: InputMaybe<StringOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
};

export type SiteParkerInput = {
  accessTimes?: InputMaybe<Array<InputMaybe<AccessTimeInput>>>;
  area?: InputMaybe<AreaInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  canBook: Scalars['Boolean'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isStrata: Scalars['Boolean'];
  parker?: InputMaybe<ParkerInput>;
  parkerId: Scalars['UUID'];
  publicDescription?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<SiteInput>;
  siteId: Scalars['UUID'];
};

export type SiteParkerSortInput = {
  area?: InputMaybe<AreaSortInput>;
  areaId?: InputMaybe<SortEnumType>;
  canBook?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isStrata?: InputMaybe<SortEnumType>;
  parker?: InputMaybe<ParkerSortInput>;
  parkerId?: InputMaybe<SortEnumType>;
  publicDescription?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SiteParkersCollectionSegment = {
  __typename?: 'SiteParkersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<SiteParker>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type SitePermissionsCollectionSegment = {
  __typename?: 'SitePermissionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Permission>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type SiteSortInput = {
  address?: InputMaybe<SortEnumType>;
  addressMetadata?: InputMaybe<SortEnumType>;
  apiKey?: InputMaybe<SortEnumType>;
  bayTypes?: InputMaybe<SortEnumType>;
  behaviourConfig?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  connectionId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  daysToStoreMessages?: InputMaybe<SortEnumType>;
  gracePeriod?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  immediateNotifications?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isListed?: InputMaybe<SortEnumType>;
  lgaName?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notificationEmails?: InputMaybe<SortEnumType>;
  notificationPhones?: InputMaybe<SortEnumType>;
  reservationBuffer?: InputMaybe<SortEnumType>;
  tariff?: InputMaybe<SortEnumType>;
  timeZone?: InputMaybe<SortEnumType>;
  token?: InputMaybe<SortEnumType>;
  welcomeMessage?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SitesCollectionSegment = {
  __typename?: 'SitesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Site>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Status = {
  __typename?: 'Status';
  caption?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  lastUpdated: Scalars['DateTime'];
  metadata?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  siteId: Scalars['UUID'];
};

export type StatusFilterInput = {
  and?: InputMaybe<Array<StatusFilterInput>>;
  caption?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  metadata?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StatusFilterInput>>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
};

export type StatusSortInput = {
  caption?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  key?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  metadata?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  siteId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type StatusesCollectionSegment = {
  __typename?: 'StatusesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Status>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  bayUpdated?: Maybe<Bay>;
  siteCommandReceived?: Maybe<SiteCommand>;
  siteMessageSent?: Maybe<SiteMessage>;
  siteUpdated?: Maybe<Site>;
  statusUpdated?: Maybe<Status>;
};


export type SubscriptionBayUpdatedArgs = {
  siteId: Scalars['UUID'];
};

export type Tariff = {
  __typename?: 'Tariff';
  area?: Maybe<Area>;
  areaId?: Maybe<Scalars['UUID']>;
  cost: Scalars['Decimal'];
  dayOfWeek: Scalars['Int'];
  hour: Scalars['Int'];
  id: Scalars['UUID'];
  pricePlan?: Maybe<PricePlan>;
  pricePlanId?: Maybe<Scalars['UUID']>;
};

export type TariffDto = {
  __typename?: 'TariffDTO';
  area?: Maybe<AreaDto>;
  areaId?: Maybe<Scalars['UUID']>;
  cost: Scalars['Decimal'];
  dayOfWeek: Scalars['Int'];
  hour: Scalars['Int'];
  id: Scalars['UUID'];
};

export type TariffFilterInput = {
  and?: InputMaybe<Array<TariffFilterInput>>;
  area?: InputMaybe<AreaFilterInput>;
  areaId?: InputMaybe<UuidOperationFilterInput>;
  cost?: InputMaybe<DecimalOperationFilterInput>;
  dayOfWeek?: InputMaybe<IntOperationFilterInput>;
  hour?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<TariffFilterInput>>;
  pricePlan?: InputMaybe<PricePlanFilterInput>;
  pricePlanId?: InputMaybe<UuidOperationFilterInput>;
};

export type TariffInput = {
  area?: InputMaybe<AreaInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  cost: Scalars['Decimal'];
  dayOfWeek: Scalars['Int'];
  hour: Scalars['Int'];
  id: Scalars['UUID'];
  pricePlan?: InputMaybe<PricePlanInput>;
  pricePlanId?: InputMaybe<Scalars['UUID']>;
};

export type TariffSortInput = {
  area?: InputMaybe<AreaSortInput>;
  areaId?: InputMaybe<SortEnumType>;
  cost?: InputMaybe<SortEnumType>;
  dayOfWeek?: InputMaybe<SortEnumType>;
  hour?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  pricePlan?: InputMaybe<PricePlanSortInput>;
  pricePlanId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type TariffsCollectionSegment = {
  __typename?: 'TariffsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Tariff>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Transaction = {
  __typename?: 'Transaction';
  amount?: Maybe<Scalars['Decimal']>;
  area?: Maybe<Area>;
  areaId?: Maybe<Scalars['UUID']>;
  assignedBayId?: Maybe<Scalars['UUID']>;
  behaviorViolations?: Maybe<Array<Maybe<BehaviorViolation>>>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  endUtc?: Maybe<Scalars['DateTime']>;
  entryMethod?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Maybe<Event>>>;
  id: Scalars['UUID'];
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  isOnSite: Scalars['Boolean'];
  isPerm: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  parker?: Maybe<Parker>;
  parkerId?: Maybe<Scalars['UUID']>;
  reservation?: Maybe<Reservation>;
  reservationId?: Maybe<Scalars['UUID']>;
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['UUID']>;
  siteMessages?: Maybe<Array<Maybe<SiteMessage>>>;
  startUtc?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
  type: TransactionType;
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars['UUID']>;
};

export type TransactionDto = {
  __typename?: 'TransactionDTO';
  amount?: Maybe<Scalars['Decimal']>;
  area?: Maybe<AreaDto>;
  areaId?: Maybe<Scalars['UUID']>;
  areaName?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  endUtc?: Maybe<Scalars['DateTime']>;
  events?: Maybe<Array<Maybe<EventDto>>>;
  id: Scalars['UUID'];
  invoices?: Maybe<Array<Maybe<InvoiceDto>>>;
  isOnSite: Scalars['Boolean'];
  isPerm: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  parker?: Maybe<ParkerDto>;
  parkerEmail?: Maybe<Scalars['String']>;
  parkerId?: Maybe<Scalars['UUID']>;
  parkerName?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  reservation?: Maybe<ReservationDto>;
  reservationId?: Maybe<Scalars['UUID']>;
  site?: Maybe<SiteDto>;
  siteId?: Maybe<Scalars['UUID']>;
  siteMessages?: Maybe<Array<Maybe<SiteMessageDto>>>;
  siteName?: Maybe<Scalars['String']>;
  startUtc?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  type: TransactionType;
  typeString?: Maybe<Scalars['String']>;
  vehicle?: Maybe<VehicleDto>;
  vehicleId?: Maybe<Scalars['UUID']>;
};

export type TransactionFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<TransactionFilterInput>>;
  area?: InputMaybe<AreaFilterInput>;
  areaId?: InputMaybe<UuidOperationFilterInput>;
  assignedBayId?: InputMaybe<UuidOperationFilterInput>;
  behaviorViolations?: InputMaybe<ListFilterInputTypeOfBehaviorViolationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  endUtc?: InputMaybe<DateTimeOperationFilterInput>;
  entryMethod?: InputMaybe<StringOperationFilterInput>;
  events?: InputMaybe<ListFilterInputTypeOfEventFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  invoices?: InputMaybe<ListFilterInputTypeOfInvoiceFilterInput>;
  isOnSite?: InputMaybe<BooleanOperationFilterInput>;
  isPerm?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<TransactionFilterInput>>;
  parker?: InputMaybe<ParkerFilterInput>;
  parkerId?: InputMaybe<UuidOperationFilterInput>;
  reservation?: InputMaybe<ReservationFilterInput>;
  reservationId?: InputMaybe<UuidOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  siteMessages?: InputMaybe<ListFilterInputTypeOfSiteMessageFilterInput>;
  startUtc?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  transactionType?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<TransactionTypeOperationFilterInput>;
  vehicle?: InputMaybe<VehicleFilterInput>;
  vehicleId?: InputMaybe<UuidOperationFilterInput>;
};

export type TransactionInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  area?: InputMaybe<AreaInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  assignedBayId?: InputMaybe<Scalars['UUID']>;
  behaviorViolations?: InputMaybe<Array<InputMaybe<BehaviorViolationInput>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  endUtc?: InputMaybe<Scalars['DateTime']>;
  entryMethod?: InputMaybe<Scalars['String']>;
  events?: InputMaybe<Array<InputMaybe<EventInput>>>;
  id: Scalars['UUID'];
  invoices?: InputMaybe<Array<InputMaybe<InvoiceInput>>>;
  isOnSite: Scalars['Boolean'];
  isPerm: Scalars['Boolean'];
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  parker?: InputMaybe<ParkerInput>;
  parkerId?: InputMaybe<Scalars['UUID']>;
  reservation?: InputMaybe<ReservationInput>;
  reservationId?: InputMaybe<Scalars['UUID']>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteMessages?: InputMaybe<Array<InputMaybe<SiteMessageInput>>>;
  startUtc?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Scalars['String']>;
  type: TransactionType;
  vehicle?: InputMaybe<VehicleInput>;
  vehicleId?: InputMaybe<Scalars['UUID']>;
};

export type TransactionSortInput = {
  amount?: InputMaybe<SortEnumType>;
  area?: InputMaybe<AreaSortInput>;
  areaId?: InputMaybe<SortEnumType>;
  assignedBayId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  endUtc?: InputMaybe<SortEnumType>;
  entryMethod?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isOnSite?: InputMaybe<SortEnumType>;
  isPerm?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  parker?: InputMaybe<ParkerSortInput>;
  parkerId?: InputMaybe<SortEnumType>;
  reservation?: InputMaybe<ReservationSortInput>;
  reservationId?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  startUtc?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  transactionType?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  vehicle?: InputMaybe<VehicleSortInput>;
  vehicleId?: InputMaybe<SortEnumType>;
};

export enum TransactionType {
  Adhoc = 'ADHOC',
  Permanent = 'PERMANENT',
  PublicReservation = 'PUBLIC_RESERVATION',
  StrataReservation = 'STRATA_RESERVATION',
  VisitorReservation = 'VISITOR_RESERVATION'
}

export type TransactionTypeOperationFilterInput = {
  eq?: InputMaybe<TransactionType>;
  in?: InputMaybe<Array<TransactionType>>;
  neq?: InputMaybe<TransactionType>;
  nin?: InputMaybe<Array<TransactionType>>;
};

/** A segment of a collection. */
export type TransactionsCollectionSegment = {
  __typename?: 'TransactionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Transaction>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  createdBy?: Maybe<Scalars['String']>;
  createdByCompany?: Maybe<Company>;
  /**
   * The company this user was created under (for company admins creating users).
   * Null for Parkagility-created users or users created before this feature.
   */
  createdByCompanyId?: Maybe<Scalars['UUID']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  identities?: Maybe<Array<Maybe<Identity>>>;
  isActive: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<Message>>>;
  mobile?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
};

export type UserDto = {
  __typename?: 'UserDTO';
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  identities?: Maybe<Array<Maybe<IdentityDto>>>;
  isActive: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  permissions?: Maybe<Array<Maybe<PermissionDto>>>;
};

export type UserFilterInput = {
  and?: InputMaybe<Array<UserFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdByCompany?: InputMaybe<CompanyFilterInput>;
  /**
   * The company this user was created under (for company admins creating users).
   * Null for Parkagility-created users or users created before this feature.
   */
  createdByCompanyId?: InputMaybe<UuidOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  identities?: InputMaybe<ListFilterInputTypeOfIdentityFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  messages?: InputMaybe<ListFilterInputTypeOfMessageFilterInput>;
  mobile?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  permissions?: InputMaybe<ListFilterInputTypeOfPermissionFilterInput>;
};

export type UserInput = {
  createdBy?: InputMaybe<Scalars['String']>;
  createdByCompany?: InputMaybe<CompanyInput>;
  /**
   * The company this user was created under (for company admins creating users).
   * Null for Parkagility-created users or users created before this feature.
   */
  createdByCompanyId?: InputMaybe<Scalars['UUID']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  identities?: InputMaybe<Array<InputMaybe<IdentityInput>>>;
  isActive: Scalars['Boolean'];
  lastName?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<MessageInput>>>;
  mobile?: InputMaybe<Scalars['String']>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  permissions?: InputMaybe<Array<InputMaybe<PermissionInput>>>;
};

export type UserSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdByCompany?: InputMaybe<CompanySortInput>;
  /**
   * The company this user was created under (for company admins creating users).
   * Null for Parkagility-created users or users created before this feature.
   */
  createdByCompanyId?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  mobile?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type UsersCollectionSegment = {
  __typename?: 'UsersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  colour?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isElectric: Scalars['Boolean'];
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  parker?: Maybe<Parker>;
  parkerId?: Maybe<Scalars['UUID']>;
  plate?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type VehicleDto = {
  __typename?: 'VehicleDTO';
  colour?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isElectric: Scalars['Boolean'];
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  parker?: Maybe<ParkerDto>;
  parkerId?: Maybe<Scalars['UUID']>;
  plate?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type VehicleFilterInput = {
  and?: InputMaybe<Array<VehicleFilterInput>>;
  colour?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isElectric?: InputMaybe<BooleanOperationFilterInput>;
  make?: InputMaybe<StringOperationFilterInput>;
  model?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<VehicleFilterInput>>;
  parker?: InputMaybe<ParkerFilterInput>;
  parkerId?: InputMaybe<UuidOperationFilterInput>;
  plate?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
};

export type VehicleInput = {
  colour?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdUtc?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isElectric: Scalars['Boolean'];
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedUtc?: InputMaybe<Scalars['DateTime']>;
  parker?: InputMaybe<ParkerInput>;
  parkerId?: InputMaybe<Scalars['UUID']>;
  plate?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type VehicleSortInput = {
  colour?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isElectric?: InputMaybe<SortEnumType>;
  make?: InputMaybe<SortEnumType>;
  model?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedUtc?: InputMaybe<SortEnumType>;
  parker?: InputMaybe<ParkerSortInput>;
  parkerId?: InputMaybe<SortEnumType>;
  plate?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type VehiclesCollectionSegment = {
  __typename?: 'VehiclesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<Vehicle>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export enum ViolationStatus {
  Detected = 'DETECTED',
  Escalated = 'ESCALATED',
  Resolved = 'RESOLVED',
  ResolvedLate = 'RESOLVED_LATE'
}

export type ViolationStatusOperationFilterInput = {
  eq?: InputMaybe<ViolationStatus>;
  in?: InputMaybe<Array<ViolationStatus>>;
  neq?: InputMaybe<ViolationStatus>;
  nin?: InputMaybe<Array<ViolationStatus>>;
};

export type GetAuditEventsQueryVariables = Exact<{
  entityId: Scalars['String'];
  entityType: Scalars['String'];
}>;


export type GetAuditEventsQuery = { __typename?: 'Query', auditEvents?: { __typename?: 'AuditEventsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'AuditEvent', id: any, eventDate: any, eventType?: string | null, userName?: string | null, entityType?: string | null, entityId?: string | null, changes?: string | null } | null> | null } | null };

export type GetAccessTimesQueryVariables = Exact<{
  siteParkerId?: InputMaybe<Scalars['UUID']>;
  where?: InputMaybe<AccessTimeFilterInput>;
}>;


export type GetAccessTimesQuery = { __typename?: 'Query', accessTimes?: { __typename?: 'AccessTimesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'AccessTime', id: any, siteId?: any | null, areaId?: any | null, siteParkerId?: any | null, dayOfWeek: DayOfWeek, start?: number | null, end?: number | null, hasAccess: boolean } | null> | null } | null };

export type UpdateAccessTimesMutationVariables = Exact<{
  accessTimes: Array<InputMaybe<AccessTimeInput>> | InputMaybe<AccessTimeInput>;
}>;


export type UpdateAccessTimesMutation = { __typename?: 'Mutation', updateAccessTimes?: Array<{ __typename?: 'AccessTime', id: any, siteId?: any | null, areaId?: any | null, dayOfWeek: DayOfWeek, start?: number | null, end?: number | null } | null> | null };

export type GetAllChangesQueryVariables = Exact<{
  where?: InputMaybe<AuditEventFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuditEventSortInput> | AuditEventSortInput>;
}>;


export type GetAllChangesQuery = { __typename?: 'Query', auditEvents?: { __typename?: 'AuditEventsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'AuditEvent', id: any, eventDate: any, eventType?: string | null, userName?: string | null, entityType?: string | null, entityId?: string | null, changes?: string | null } | null> | null } | null };

export type GetCompaniesQueryVariables = Exact<{
  where?: InputMaybe<CompanyFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySortInput> | CompanySortInput>;
}>;


export type GetCompaniesQuery = { __typename?: 'Query', companies?: { __typename?: 'CompaniesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Company', id: any, name?: string | null, abn?: string | null, address?: string | null, isActive: boolean } | null> | null } | null };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', companies?: { __typename?: 'CompaniesCollectionSegment', items?: Array<{ __typename?: 'Company', id: any, name?: string | null, abn?: string | null, address?: string | null, addressMetadata?: string | null, isActive: boolean, comments?: string | null, createdUtc?: any | null, createdBy?: string | null, modifiedUtc?: any | null, modifiedBy?: string | null } | null> | null } | null };

export type UpdateCompanyMutationVariables = Exact<{
  company: CompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany?: { __typename?: 'Company', id: any, name?: string | null, abn?: string | null, address?: string | null, addressMetadata?: string | null, isActive: boolean, comments?: string | null, createdUtc?: any | null, createdBy?: string | null, modifiedUtc?: any | null, modifiedBy?: string | null } | null };

export type GetImagesQueryVariables = Exact<{
  where?: InputMaybe<ImageFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ImageSortInput> | ImageSortInput>;
}>;


export type GetImagesQuery = { __typename?: 'Query', images?: { __typename?: 'ImagesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Image', id: any, url?: string | null, imageUrl?: string | null, capturedUtc: any, siteId: any, bayId?: any | null, accessLaneId?: any | null, site?: { __typename?: 'Site', name?: string | null } | null, bay?: { __typename?: 'Bay', name?: string | null } | null, accessLane?: { __typename?: 'AccessLane', name?: string | null } | null } | null> | null } | null };

export type GetMessageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetMessageQuery = { __typename?: 'Query', messages?: { __typename?: 'MessagesCollectionSegment', items?: Array<{ __typename?: 'Message', id: any, parkerId?: any | null, userId?: any | null, recipient?: string | null, content?: string | null, messageType?: string | null, sentTime: any, isSent: boolean, site?: { __typename?: 'Site', id: any, name?: string | null } | null } | null> | null } | null };

export type GetMessagesQueryVariables = Exact<{
  where?: InputMaybe<MessageFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessageSortInput> | MessageSortInput>;
}>;


export type GetMessagesQuery = { __typename?: 'Query', messages?: { __typename?: 'MessagesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Message', id: any, parkerId?: any | null, userId?: any | null, recipient?: string | null, messageType?: string | null, sentTime: any, isSent: boolean, site?: { __typename?: 'Site', id: any, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetParkerQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetParkerQuery = { __typename?: 'Query', parkers?: { __typename?: 'ParkersCollectionSegment', items?: Array<{ __typename?: 'Parker', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, createdUtc?: any | null, isActive: boolean, isEmailVerified: boolean, qrCode?: any | null, uid?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, state?: string | null, postcode?: string | null, notificationType?: string | null, agreeTermsConditions?: any | null, stripeCustomerId?: string | null, stripeMetadata?: string | null, stripeDefaultPaymentMethodId?: string | null, isProfileComplete?: boolean | null } | null> | null } | null };

export type UpdateParkerMutationVariables = Exact<{
  parker: ParkerInput;
}>;


export type UpdateParkerMutation = { __typename?: 'Mutation', updateParker?: { __typename?: 'Parker', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, createdUtc?: any | null, isActive: boolean, isEmailVerified: boolean, qrCode?: any | null } | null };

export type ReissueQrCodeMutationVariables = Exact<{
  parker: ParkerInput;
}>;


export type ReissueQrCodeMutation = { __typename?: 'Mutation', reissueQrCode?: { __typename?: 'Parker', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, createdUtc?: any | null, isActive: boolean, isEmailVerified: boolean, qrCode?: any | null } | null };

export type GetParkersQueryVariables = Exact<{
  where?: InputMaybe<ParkerFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ParkerSortInput> | ParkerSortInput>;
}>;


export type GetParkersQuery = { __typename?: 'Query', parkers?: { __typename?: 'ParkersCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'Parker', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, createdUtc?: any | null, isActive: boolean, stripeCustomerId?: string | null, isEmailVerified: boolean, isProfileComplete?: boolean | null, notificationType?: string | null } | null> | null } | null };

export type RefreshParkerStripeDataMutationVariables = Exact<{
  parkerId: Scalars['UUID'];
}>;


export type RefreshParkerStripeDataMutation = { __typename?: 'Mutation', refreshParkerStripeData?: { __typename?: 'Parker', id: any, stripeCustomerId?: string | null, stripeMetadata?: string | null, stripeDefaultPaymentMethodId?: string | null } | null };

export type GetSitesAndSiteParkersQueryVariables = Exact<{
  siteId?: InputMaybe<Scalars['UUID']>;
  where?: InputMaybe<SiteParkerFilterInput>;
}>;


export type GetSitesAndSiteParkersQuery = { __typename?: 'Query', siteParkers?: { __typename?: 'SiteParkersCollectionSegment', items?: Array<{ __typename?: 'SiteParker', id: any, siteId: any, areaId?: any | null, parkerId: any, isStrata: boolean, canBook: boolean, isActive: boolean, parker?: { __typename?: 'Parker', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, createdUtc?: any | null, isActive: boolean } | null } | null> | null } | null, sites?: { __typename?: 'SitesCollectionSegment', items?: Array<{ __typename?: 'Site', id: any, name?: string | null, areas?: Array<{ __typename?: 'Area', id: any, name?: string | null } | null> | null } | null> | null } | null };

export type AddPermanentParkerMutationVariables = Exact<{
  email: Scalars['String'];
  siteId: Scalars['UUID'];
  isStrata: Scalars['Boolean'];
  canBook: Scalars['Boolean'];
}>;


export type AddPermanentParkerMutation = { __typename?: 'Mutation', addPermanentParker?: { __typename?: 'SiteParker', id: any, isStrata: boolean, canBook: boolean, parker?: { __typename?: 'Parker', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, createdUtc?: any | null, isActive: boolean } | null, site?: { __typename?: 'Site', id: any, name?: string | null } | null } | null };

export type UpdatePermanentSiteParkerMutationVariables = Exact<{
  siteParker: SiteParkerInput;
}>;


export type UpdatePermanentSiteParkerMutation = { __typename?: 'Mutation', updatePermanentParker?: { __typename?: 'SiteParker', id: any, isStrata: boolean, canBook: boolean, parker?: { __typename?: 'Parker', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, createdUtc?: any | null, isActive: boolean } | null, site?: { __typename?: 'Site', id: any, name?: string | null } | null, area?: { __typename?: 'Area', id: any, name?: string | null } | null } | null };

export type GetSiteParkersQueryVariables = Exact<{
  where?: InputMaybe<SiteParkerFilterInput>;
}>;


export type GetSiteParkersQuery = { __typename?: 'Query', siteParkers?: { __typename?: 'SiteParkersCollectionSegment', items?: Array<{ __typename?: 'SiteParker', id: any, siteId: any, parkerId: any, isStrata: boolean, canBook: boolean, isActive: boolean, parker?: { __typename?: 'Parker', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, createdUtc?: any | null, isActive: boolean } | null, site?: { __typename?: 'Site', id: any, name?: string | null, isActive: boolean } | null, area?: { __typename?: 'Area', id: any, name?: string | null } | null } | null> | null } | null };

export type GetPermissionQueryVariables = Exact<{
  permissionId: Scalars['UUID'];
  userId: Scalars['UUID'];
}>;


export type GetPermissionQuery = { __typename?: 'Query', users?: { __typename?: 'UsersCollectionSegment', items?: Array<{ __typename?: 'User', id: any, email?: string | null, firstName?: string | null, lastName?: string | null } | null> | null } | null, permissions?: { __typename?: 'PermissionsCollectionSegment', items?: Array<{ __typename?: 'Permission', id: any, userId?: any | null, siteId?: any | null, companyId?: any | null, areaId?: any | null, role?: string | null } | null> | null } | null, companies?: { __typename?: 'CompaniesCollectionSegment', items?: Array<{ __typename?: 'Company', id: any, name?: string | null, isActive: boolean } | null> | null } | null, sites?: { __typename?: 'SitesCollectionSegment', items?: Array<{ __typename?: 'Site', id: any, companyId: any, name?: string | null, isActive: boolean } | null> | null } | null, areas?: { __typename?: 'AreasCollectionSegment', items?: Array<{ __typename?: 'Area', id: any, name?: string | null, siteId: any, site?: { __typename?: 'Site', id: any, name?: string | null } | null } | null> | null } | null, myPermissions?: Array<{ __typename?: 'Permission', id: any, companyId?: any | null, siteId?: any | null, areaId?: any | null, role?: string | null } | null> | null };

export type UpdatePermissionMutationVariables = Exact<{
  permission: PermissionInput;
}>;


export type UpdatePermissionMutation = { __typename?: 'Mutation', updatePermission?: { __typename?: 'Permission', id: any, userId?: any | null, siteId?: any | null, companyId?: any | null, areaId?: any | null, role?: string | null } | null };

export type GetPermissionsQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type GetPermissionsQuery = { __typename?: 'Query', permissions?: { __typename?: 'PermissionsCollectionSegment', items?: Array<{ __typename?: 'Permission', id: any, userId?: any | null, role?: string | null, company?: { __typename?: 'Company', id: any, name?: string | null } | null, site?: { __typename?: 'Site', id: any, name?: string | null } | null, area?: { __typename?: 'Area', id: any, name?: string | null, site?: { __typename?: 'Site', id: any, name?: string | null } | null } | null } | null> | null } | null, users?: { __typename?: 'UsersCollectionSegment', items?: Array<{ __typename?: 'User', id: any, email?: string | null, firstName?: string | null, lastName?: string | null } | null> | null } | null };

export type DeletePermissionsMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeletePermissionsMutation = { __typename?: 'Mutation', deletePermission: boolean };

export type GetPricePlanQueryVariables = Exact<{
  siteId: Scalars['UUID'];
  pricePlanId: Scalars['UUID'];
}>;


export type GetPricePlanQuery = { __typename?: 'Query', pricePlans?: { __typename?: 'PricePlansCollectionSegment', items?: Array<{ __typename?: 'PricePlan', id: any, name?: string | null, startDate: any, endDate?: any | null, isActive: boolean } | null> | null } | null };

export type GetSiteWithAreasQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetSiteWithAreasQuery = { __typename?: 'Query', sites?: { __typename?: 'SitesCollectionSegment', items?: Array<{ __typename?: 'Site', id: any, name?: string | null, areas?: Array<{ __typename?: 'Area', id: any, name?: string | null, capacity: number } | null> | null } | null> | null } | null };

export type UpdatePricePlanMutationVariables = Exact<{
  pricePlan: PricePlanInput;
}>;


export type UpdatePricePlanMutation = { __typename?: 'Mutation', updatePricePlan?: { __typename?: 'PricePlan', id: any, name?: string | null, startDate: any, endDate?: any | null, isActive: boolean } | null };

export type GetPricePlansQueryVariables = Exact<{
  siteId: Scalars['UUID'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetPricePlansQuery = { __typename?: 'Query', pricePlans?: { __typename?: 'PricePlansCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PricePlan', id: any, name?: string | null, startDate: any, endDate?: any | null, isActive: boolean } | null> | null } | null };

export type GetTariffsQueryVariables = Exact<{
  siteId: Scalars['UUID'];
}>;


export type GetTariffsQuery = { __typename?: 'Query', tariffs?: { __typename?: 'TariffsCollectionSegment', items?: Array<{ __typename?: 'Tariff', id: any, areaId?: any | null, dayOfWeek: number, hour: number, cost: any } | null> | null } | null };

export type UpdateTariffsMutationVariables = Exact<{
  tariffs: Array<InputMaybe<TariffInput>> | InputMaybe<TariffInput>;
}>;


export type UpdateTariffsMutation = { __typename?: 'Mutation', updateTariffs?: Array<{ __typename?: 'Tariff', id: any, areaId?: any | null, dayOfWeek: number, hour: number, cost: any } | null> | null };

export type GetProductsAndSitesQueryVariables = Exact<{
  siteId: Scalars['UUID'];
  where?: InputMaybe<ProductFilterInput>;
}>;


export type GetProductsAndSitesQuery = { __typename?: 'Query', products?: { __typename?: 'ProductsCollectionSegment', items?: Array<{ __typename?: 'Product', id: any, name?: string | null, description?: string | null, siteId: any, pricePerHour?: any | null, maxPricePerDay?: any | null, isActive: boolean, productTimesJson?: string | null, mustArriveBefore?: number | null, mustDepartAfter?: number | null, mustArriveAfter?: number | null, mustDepartBefore?: number | null } | null> | null } | null, sites?: { __typename?: 'SitesCollectionSegment', items?: Array<{ __typename?: 'Site', id: any, name?: string | null } | null> | null } | null };

export type UpdateProductMutationVariables = Exact<{
  product: ProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct?: { __typename?: 'ProductDTO', id: any, name?: string | null, description?: string | null, siteId: any, pricePerHour?: any | null, maxPricePerDay?: any | null, isActive: boolean, productTimesJson?: string | null, mustArriveBefore?: number | null, mustDepartAfter?: number | null, mustArriveAfter?: number | null, mustDepartBefore?: number | null } | null };

export type GetEventsQueryVariables = Exact<{
  where?: InputMaybe<EventFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSortInput> | EventSortInput>;
}>;


export type GetEventsQuery = { __typename?: 'Query', events?: { __typename?: 'EventsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Event', id: any, createdUtc?: any | null, type?: string | null, message?: string | null, transaction?: { __typename?: 'Transaction', id: any, startUtc?: any | null, parker?: { __typename?: 'Parker', id: any, firstName?: string | null, lastName?: string | null, fullName?: string | null } | null } | null, site?: { __typename?: 'Site', id: any, name?: string | null } | null } | null> | null } | null };

export type GetBehaviorViolationsQueryVariables = Exact<{
  where?: InputMaybe<BehaviorViolationFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BehaviorViolationSortInput> | BehaviorViolationSortInput>;
}>;


export type GetBehaviorViolationsQuery = { __typename?: 'Query', behaviorViolations?: { __typename?: 'BehaviorViolationsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BehaviorViolation', id: any, violationType: BehaviorViolationType, detectedUtc: any, escalationScheduledUtc?: any | null, resolvedUtc?: any | null, status: ViolationStatus, description?: string | null, escalationNotes?: string | null, transaction?: { __typename?: 'Transaction', id: any, startUtc?: any | null, parker?: { __typename?: 'Parker', id: any, firstName?: string | null, lastName?: string | null, fullName?: string | null } | null } | null, site?: { __typename?: 'Site', id: any, name?: string | null } | null } | null> | null } | null };

export type GetInvoicesQueryVariables = Exact<{
  where?: InputMaybe<InvoiceFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceSortInput> | InvoiceSortInput>;
}>;


export type GetInvoicesQuery = { __typename?: 'Query', invoices?: { __typename?: 'InvoicesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Invoice', id: any, createdUtc?: any | null, transactionId: any, amount: any, status?: string | null, stripeInvoiceNumber?: string | null, stripeInvoicePdfUrl?: string | null, stripeError?: string | null, parker?: { __typename?: 'Parker', id: any, fullName?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, transaction?: { __typename?: 'Transaction', id: any, startUtc?: any | null, endUtc?: any | null, site?: { __typename?: 'Site', id: any, name?: string | null } | null } | null } | null> | null } | null };

export type GetReservationQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetReservationQuery = { __typename?: 'Query', reservations?: { __typename?: 'ReservationsCollectionSegment', items?: Array<{ __typename?: 'Reservation', id: any, status?: string | null, createdUtc?: any | null, createdBy?: string | null, modifiedUtc?: any | null, modifiedBy?: string | null, uid?: string | null, name?: string | null, siteId?: any | null, email?: string | null, mobile?: string | null, plate?: string | null, startDate?: string | null, startTime?: string | null, endDate?: string | null, endTime?: string | null, isActive: boolean, source?: string | null, bayType?: string | null, isPermanentParker: boolean, site?: { __typename?: 'Site', name?: string | null } | null, transactions?: Array<{ __typename?: 'Transaction', id: any } | null> | null, parker?: { __typename?: 'Parker', id: any, firstName?: string | null, lastName?: string | null, email?: string | null, mobile?: string | null } | null, vehicle?: { __typename?: 'Vehicle', id: any, plate?: string | null } | null } | null> | null } | null, sites?: { __typename?: 'SitesCollectionSegment', items?: Array<{ __typename?: 'Site', id: any, name?: string | null, isActive: boolean } | null> | null } | null };

export type HaveCapacityQueryVariables = Exact<{
  areaId?: InputMaybe<Scalars['UUID']>;
  siteId: Scalars['UUID'];
  reservationId?: InputMaybe<Scalars['UUID']>;
  start: Scalars['String'];
  end: Scalars['String'];
}>;


export type HaveCapacityQuery = { __typename?: 'Query', haveCapacity?: { __typename?: 'HaveCapacityResult', haveCapacity?: boolean | null, error?: string | null } | null };

export type UpdateReservationMutationVariables = Exact<{
  reservation: ReservationInput;
}>;


export type UpdateReservationMutation = { __typename?: 'Mutation', updateReservation?: { __typename?: 'Reservation', id: any, status?: string | null, createdUtc?: any | null, createdBy?: string | null, modifiedUtc?: any | null, modifiedBy?: string | null, uid?: string | null, name?: string | null, siteId?: any | null, email?: string | null, mobile?: string | null, plate?: string | null, startDate?: string | null, startTime?: string | null, endDate?: string | null, endTime?: string | null, isActive: boolean, source?: string | null, bayType?: string | null, isPermanentParker: boolean, site?: { __typename?: 'Site', name?: string | null } | null, transactions?: Array<{ __typename?: 'Transaction', id: any } | null> | null, parker?: { __typename?: 'Parker', id: any, firstName?: string | null, lastName?: string | null, email?: string | null, mobile?: string | null } | null, vehicle?: { __typename?: 'Vehicle', id: any, plate?: string | null } | null } | null };

export type GetReservationsQueryVariables = Exact<{
  where?: InputMaybe<ReservationFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReservationSortInput> | ReservationSortInput>;
}>;


export type GetReservationsQuery = { __typename?: 'Query', reservations?: { __typename?: 'ReservationsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Reservation', id: any, status?: string | null, createdUtc?: any | null, name?: string | null, siteId?: any | null, areaId?: any | null, email?: string | null, mobile?: string | null, plate?: string | null, startUtc?: any | null, startDate?: string | null, startTime?: string | null, endUtc?: any | null, endDate?: string | null, endTime?: string | null, isActive: boolean, isPermanentParker: boolean, source?: string | null, sourceType: ReservationSource, bayType?: string | null, site?: { __typename?: 'Site', name?: string | null } | null, parker?: { __typename?: 'Parker', id: any, firstName?: string | null, lastName?: string | null, email?: string | null, mobile?: string | null } | null, vehicle?: { __typename?: 'Vehicle', id: any, plate?: string | null } | null } | null> | null } | null };

export type GetSiteCommandsQueryVariables = Exact<{
  where?: InputMaybe<SiteCommandFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteCommandSortInput> | SiteCommandSortInput>;
}>;


export type GetSiteCommandsQuery = { __typename?: 'Query', siteCommands?: { __typename?: 'SiteCommandsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'SiteCommand', id: any, siteId: any, type?: string | null, createdUtc: any, payload?: string | null, response?: string | null, site?: { __typename?: 'Site', name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type SiteCommandReceivedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SiteCommandReceivedSubscription = { __typename?: 'Subscription', siteCommandReceived?: { __typename?: 'SiteCommand', id: any, siteId: any, type?: string | null, createdUtc: any, payload?: string | null, response?: string | null } | null };

export type GetSiteMessagesQueryVariables = Exact<{
  where?: InputMaybe<SiteMessageFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteMessageSortInput> | SiteMessageSortInput>;
}>;


export type GetSiteMessagesQuery = { __typename?: 'Query', siteMessages?: { __typename?: 'SiteMessagesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'SiteMessage', id: any, siteId: any, type?: string | null, createdUtc: any, payload?: string | null, response?: string | null, sequenceId: any, duration: any, transactionId?: any | null, site?: { __typename?: 'Site', name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type SiteMessageSentSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SiteMessageSentSubscription = { __typename?: 'Subscription', siteMessageSent?: { __typename?: 'SiteMessage', id: any, siteId: any, type?: string | null, createdUtc: any, payload?: string | null, response?: string | null, sequenceId: any, duration: any, transactionId?: any | null, site?: { __typename?: 'Site', name?: string | null } | null } | null };

export type GetCapacitiesQueryVariables = Exact<{
  siteId: Scalars['UUID'];
}>;


export type GetCapacitiesQuery = { __typename?: 'Query', capacities?: { __typename?: 'CapacitiesCollectionSegment', items?: Array<{ __typename?: 'Capacity', id: any, areaId?: any | null, dayOfWeek: number, hour: number, public: number, permanent: number, visitor: number, strata: number, total: number } | null> | null } | null };

export type UpdateCapacitiesMutationVariables = Exact<{
  capacities: Array<InputMaybe<CapacityInput>> | InputMaybe<CapacityInput>;
}>;


export type UpdateCapacitiesMutation = { __typename?: 'Mutation', updateCapacities?: Array<{ __typename?: 'Capacity', id: any, areaId?: any | null, dayOfWeek: number, hour: number, public: number, permanent: number, visitor: number, strata: number } | null> | null };

export type GetSitePermissionsQueryVariables = Exact<{
  siteId: Scalars['UUID'];
}>;


export type GetSitePermissionsQuery = { __typename?: 'Query', sitePermissions?: { __typename?: 'SitePermissionsCollectionSegment', items?: Array<{ __typename?: 'Permission', id: any, role?: string | null, company?: { __typename?: 'Company', id: any, name?: string | null } | null, site?: { __typename?: 'Site', id: any, name?: string | null } | null, area?: { __typename?: 'Area', id: any, name?: string | null } | null, user?: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null> | null } | null };

export type GetProductsQueryVariables = Exact<{
  siteId: Scalars['UUID'];
}>;


export type GetProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductsCollectionSegment', items?: Array<{ __typename?: 'Product', id: any, name?: string | null, description?: string | null, isActive: boolean, productTimes?: Array<{ __typename?: 'ProductTime', dayOfWeek: number, hour: number } | null> | null } | null> | null } | null };

export type GetSiteQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetSiteQuery = { __typename?: 'Query', sites?: { __typename?: 'SitesCollectionSegment', items?: Array<{ __typename?: 'Site', id: any, name?: string | null, companyId: any, apiKey?: string | null, daysToStoreMessages: number, isActive: boolean, isListed: boolean, address?: string | null, addressMetadata?: string | null, lgaName?: string | null, welcomeMessage?: string | null, gracePeriod: number, reservationBuffer: number, timeZone?: string | null, notificationEmails?: string | null, notificationPhones?: string | null, immediateNotifications: boolean, behaviourConfig?: string | null, createdUtc?: any | null, createdBy?: string | null, modifiedUtc?: any | null, modifiedBy?: string | null, areas?: Array<{ __typename?: 'Area', id: any, name?: string | null, capacity: number } | null> | null } | null> | null } | null, companies?: { __typename?: 'CompaniesCollectionSegment', items?: Array<{ __typename?: 'Company', id: any, name?: string | null, isActive: boolean } | null> | null } | null };

export type UpdateSiteMutationVariables = Exact<{
  site: SiteInput;
}>;


export type UpdateSiteMutation = { __typename?: 'Mutation', updateSite?: { __typename?: 'Site', id: any, companyId: any, name?: string | null, apiKey?: string | null, daysToStoreMessages: number, isActive: boolean, isListed: boolean, address?: string | null, addressMetadata?: string | null, lgaName?: string | null, welcomeMessage?: string | null, gracePeriod: number, reservationBuffer: number, timeZone?: string | null, notificationEmails?: string | null, notificationPhones?: string | null, immediateNotifications: boolean, behaviourConfig?: string | null, createdUtc?: any | null, createdBy?: string | null, modifiedUtc?: any | null, modifiedBy?: string | null, company?: { __typename?: 'Company', id: any, name?: string | null } | null } | null };

export type GetSitesQueryVariables = Exact<{
  where?: InputMaybe<SiteFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteSortInput> | SiteSortInput>;
}>;


export type GetSitesQuery = { __typename?: 'Query', sites?: { __typename?: 'SitesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Site', id: any, name?: string | null, lgaName?: string | null, isListed: boolean, connectionId?: string | null, isActive: boolean, company?: { __typename?: 'Company', id: any, name?: string | null } | null } | null> | null } | null };

export type GetBaysQueryVariables = Exact<{
  siteId: Scalars['UUID'];
}>;


export type GetBaysQuery = { __typename?: 'Query', bays?: { __typename?: 'BaysCollectionSegment', items?: Array<{ __typename?: 'Bay', id: any, name?: string | null, areaId: any, number?: string | null, isOccupied: boolean, isOverstay: boolean, senseIqId: number, type?: string | null } | null> | null } | null };

export type UpdateBayMutationVariables = Exact<{
  bay?: InputMaybe<BayInput>;
}>;


export type UpdateBayMutation = { __typename?: 'Mutation', updateBay?: { __typename?: 'Bay', id: any, name?: string | null, areaId: any, number?: string | null, isOccupied: boolean, isOverstay: boolean, senseIqId: number, type?: string | null } | null };

export type TriggerRefreshMutationVariables = Exact<{
  siteId: Scalars['UUID'];
}>;


export type TriggerRefreshMutation = { __typename?: 'Mutation', triggerRefresh?: { __typename?: 'SiteCommand', id: any } | null };

export type BayUpdatedSubscriptionVariables = Exact<{
  siteId: Scalars['UUID'];
}>;


export type BayUpdatedSubscription = { __typename?: 'Subscription', bayUpdated?: { __typename?: 'Bay', id: any, name?: string | null, areaId: any, number?: string | null, isOccupied: boolean, isOverstay: boolean, senseIqId: number, type?: string | null } | null };

export type GetSitesForStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSitesForStatusQuery = { __typename?: 'Query', sites?: { __typename?: 'SitesCollectionSegment', items?: Array<{ __typename?: 'Site', id: any, name?: string | null, lgaName?: string | null, connectionId?: string | null, isActive: boolean, company?: { __typename?: 'Company', id: any, name?: string | null } | null } | null> | null } | null };

export type GetSiteConnectionEventsQueryVariables = Exact<{
  siteId: Scalars['UUID'];
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetSiteConnectionEventsQuery = { __typename?: 'Query', siteConnectionEvents?: { __typename?: 'SiteConnectionEventsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'SiteConnectionEvent', id: any, siteId: any, connectionId?: string | null, eventType?: string | null, createdUtc: any, ipAddress?: string | null, disconnectReason?: string | null } | null> | null } | null };

export type SiteStatusUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SiteStatusUpdatedSubscription = { __typename?: 'Subscription', siteUpdated?: { __typename?: 'Site', id: any, name?: string | null, lgaName?: string | null, connectionId?: string | null, isActive: boolean } | null };

export type GetSitesAreasAndLanesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSitesAreasAndLanesQuery = { __typename?: 'Query', sites?: { __typename?: 'SitesCollectionSegment', items?: Array<{ __typename?: 'Site', id: any, name?: string | null, isActive: boolean, company?: { __typename?: 'Company', id: any, name?: string | null } | null } | null> | null } | null, areas?: { __typename?: 'AreasCollectionSegment', items?: Array<{ __typename?: 'Area', id: any, siteId: any, senseIqId: number, name?: string | null, pgsEnabled: boolean, isActive: boolean } | null> | null } | null, accessLanes?: { __typename?: 'AccessLanesCollectionSegment', items?: Array<{ __typename?: 'AccessLane', id: any, siteId: any, senseIqId: number, name?: string | null, fromAreaId?: number | null, toAreaId?: number | null, hasQrReader: boolean, hasAnpr: boolean } | null> | null } | null };

export type GetTestingBaysQueryVariables = Exact<{
  siteId: Scalars['UUID'];
}>;


export type GetTestingBaysQuery = { __typename?: 'Query', bays?: { __typename?: 'BaysCollectionSegment', items?: Array<{ __typename?: 'Bay', id: any, name?: string | null, areaId: any, number?: string | null, isOccupied: boolean, isOverstay: boolean, senseIqId: number, isActive: boolean } | null> | null } | null };

export type SendMessageMutationVariables = Exact<{
  siteId: Scalars['UUID'];
  type: Scalars['String'];
  message: Scalars['String'];
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage?: { __typename?: 'SiteMessage', id: any, siteId: any, type?: string | null, createdUtc: any, payload?: string | null, response?: string | null, sequenceId: any, duration: any } | null };

export type ClearSiteDataMutationVariables = Exact<{
  siteId: Scalars['UUID'];
}>;


export type ClearSiteDataMutation = { __typename?: 'Mutation', clearSiteData?: { __typename?: 'Site', id: any } | null };

export type BayTestingUpdatedSubscriptionVariables = Exact<{
  siteId: Scalars['UUID'];
}>;


export type BayTestingUpdatedSubscription = { __typename?: 'Subscription', bayUpdated?: { __typename?: 'Bay', id: any, name?: string | null, areaId: any, number?: string | null, isOccupied: boolean, isOverstay: boolean, senseIqId: number } | null };

export type GetTransactionQueryVariables = Exact<{
  transactionId: Scalars['UUID'];
}>;


export type GetTransactionQuery = { __typename?: 'Query', transactionById?: { __typename?: 'Transaction', id: any, type: TransactionType, transactionType?: string | null, startUtc?: any | null, endUtc?: any | null, area?: { __typename?: 'Area', id: any, name?: string | null } | null, site?: { __typename?: 'Site', id: any, name?: string | null } | null, reservation?: { __typename?: 'Reservation', id: any, startDate?: string | null, startTime?: string | null, endDate?: string | null, endTime?: string | null, name?: string | null, email?: string | null, mobile?: string | null, plate?: string | null, parkerId?: any | null, vehicleId?: any | null } | null, parker?: { __typename?: 'Parker', id: any, firstName?: string | null, lastName?: string | null } | null, vehicle?: { __typename?: 'Vehicle', id: any, plate?: string | null } | null, siteMessages?: Array<{ __typename?: 'SiteMessage', id: any, type?: string | null, payload?: string | null, response?: string | null, duration: any, createdUtc: any } | null> | null, events?: Array<{ __typename?: 'Event', id: any, type?: string | null, message?: string | null, createdUtc?: any | null } | null> | null, behaviorViolations?: Array<{ __typename?: 'BehaviorViolation', id: any, violationType: BehaviorViolationType, detectedUtc: any, escalationScheduledUtc?: any | null, resolvedUtc?: any | null, status: ViolationStatus, description?: string | null, escalationNotes?: string | null } | null> | null, invoices?: Array<{ __typename?: 'Invoice', id: any, createdUtc?: any | null, amount: any, status?: string | null, stripeInvoiceId?: string | null, stripeInvoiceNumber?: string | null, stripeInvoicePdfUrl?: string | null, stripeError?: string | null, stripeErrorUtc?: any | null, invoiceItems?: Array<{ __typename?: 'InvoiceItem', id: any, amount: any, description?: string | null, quantity: number, unitPrice: any, stripeId?: string | null } | null> | null } | null> | null } | null };

export type ResetTransactionMutationVariables = Exact<{
  transactionId: Scalars['UUID'];
}>;


export type ResetTransactionMutation = { __typename?: 'Mutation', resetTransaction?: { __typename?: 'Transaction', id: any } | null };

export type TerminateTransactionMutationVariables = Exact<{
  transactionId: Scalars['UUID'];
}>;


export type TerminateTransactionMutation = { __typename?: 'Mutation', terminateTransaction?: { __typename?: 'Transaction', id: any, endUtc?: any | null, isOnSite: boolean } | null };

export type RetryStripeInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['UUID'];
}>;


export type RetryStripeInvoiceMutation = { __typename?: 'Mutation', retryStripeInvoice?: { __typename?: 'Invoice', id: any, stripeError?: string | null } | null };

export type GetTransactionsQueryVariables = Exact<{
  where?: InputMaybe<TransactionFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TransactionSortInput> | TransactionSortInput>;
}>;


export type GetTransactionsQuery = { __typename?: 'Query', transactions?: { __typename?: 'TransactionsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Transaction', id: any, type: TransactionType, transactionType?: string | null, startUtc?: any | null, endUtc?: any | null, isPerm: boolean, isOnSite: boolean, amount?: any | null, reservation?: { __typename?: 'Reservation', id: any, sourceType: ReservationSource } | null, parker?: { __typename?: 'Parker', id: any, firstName?: string | null, lastName?: string | null, email?: string | null } | null, vehicle?: { __typename?: 'Vehicle', id: any, plate?: string | null } | null, site?: { __typename?: 'Site', id: any, name?: string | null } | null, area?: { __typename?: 'Area', id: any, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetUserQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetUserQuery = { __typename?: 'Query', users?: { __typename?: 'UsersCollectionSegment', items?: Array<{ __typename?: 'User', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, createdUtc?: any | null, modifiedUtc?: any | null, createdBy?: string | null, modifiedBy?: string | null, isActive: boolean } | null> | null } | null };

export type UpdateUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, createdUtc?: any | null, modifiedUtc?: any | null, createdBy?: string | null, modifiedBy?: string | null, isActive: boolean } | null };

export type GetUsersQueryVariables = Exact<{
  where?: InputMaybe<UserFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSortInput> | UserSortInput>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'User', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, isActive: boolean } | null> | null } | null };

export type GetVehicleQueryVariables = Exact<{
  vehicleId: Scalars['UUID'];
}>;


export type GetVehicleQuery = { __typename?: 'Query', vehicles?: { __typename?: 'VehiclesCollectionSegment', items?: Array<{ __typename?: 'Vehicle', id: any, parkerId?: any | null, plate?: string | null, make?: string | null, model?: string | null, colour?: string | null, state?: string | null, isActive: boolean, isElectric: boolean, createdUtc?: any | null, createdBy?: string | null, modifiedUtc?: any | null, modifiedBy?: string | null, parker?: { __typename?: 'Parker', id: any, email?: string | null, firstName?: string | null, lastName?: string | null } | null } | null> | null } | null };

export type UpdateVehicleMutationVariables = Exact<{
  vehicle: VehicleInput;
}>;


export type UpdateVehicleMutation = { __typename?: 'Mutation', updateVehicle?: { __typename?: 'Vehicle', id: any, parkerId?: any | null, plate?: string | null, make?: string | null, model?: string | null, colour?: string | null, state?: string | null, isActive: boolean, isElectric: boolean, createdUtc?: any | null, createdBy?: string | null, modifiedUtc?: any | null, modifiedBy?: string | null, parker?: { __typename?: 'Parker', id: any, email?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetVehiclesQueryVariables = Exact<{
  filter?: InputMaybe<VehicleFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VehicleSortInput> | VehicleSortInput>;
}>;


export type GetVehiclesQuery = { __typename?: 'Query', vehicles?: { __typename?: 'VehiclesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Vehicle', id: any, parkerId?: any | null, plate?: string | null, make?: string | null, model?: string | null, colour?: string | null, state?: string | null, isActive: boolean, isElectric: boolean, parker?: { __typename?: 'Parker', id: any, email?: string | null, firstName?: string | null, lastName?: string | null } | null } | null> | null } | null };


export const GetAuditEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuditEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entityType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventDate"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventDate"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"changes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetAuditEventsQuery, GetAuditEventsQueryVariables>;
export const GetAccessTimesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccessTimes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteParkerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessTimeFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessTimes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteParkerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteParkerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"siteParkerId"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"hasAccess"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccessTimesQuery, GetAccessTimesQueryVariables>;
export const UpdateAccessTimesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAccessTimes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessTimes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessTimeInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccessTimes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessTimes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessTimes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]} as unknown as DocumentNode<UpdateAccessTimesMutation, UpdateAccessTimesMutationVariables>;
export const GetAllChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AuditEventFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuditEventSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventDate"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"changes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetAllChangesQuery, GetAllChangesQueryVariables>;
export const GetCompaniesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abn"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const GetCompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abn"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"}}]}}]}}]}}]} as unknown as DocumentNode<GetCompanyQuery, GetCompanyQueryVariables>;
export const UpdateCompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCompany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"company"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"company"},"value":{"kind":"Variable","name":{"kind":"Name","value":"company"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abn"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"}}]}}]}}]} as unknown as DocumentNode<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const GetImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"capturedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bayId"}},{"kind":"Field","name":{"kind":"Name","value":"bay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessLaneId"}},{"kind":"Field","name":{"kind":"Name","value":"accessLane"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetImagesQuery, GetImagesQueryVariables>;
export const GetMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parkerId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recipient"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"sentTime"}},{"kind":"Field","name":{"kind":"Name","value":"isSent"}}]}}]}}]}}]} as unknown as DocumentNode<GetMessageQuery, GetMessageQueryVariables>;
export const GetMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parkerId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recipient"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"sentTime"}},{"kind":"Field","name":{"kind":"Name","value":"isSent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetMessagesQuery, GetMessagesQueryVariables>;
export const GetParkerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetParker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"qrCode"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"agreeTermsConditions"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"stripeDefaultPaymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"isProfileComplete"}}]}}]}}]}}]} as unknown as DocumentNode<GetParkerQuery, GetParkerQueryVariables>;
export const UpdateParkerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateParker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParkerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateParker"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parker"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parker"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"qrCode"}}]}}]}}]} as unknown as DocumentNode<UpdateParkerMutation, UpdateParkerMutationVariables>;
export const ReissueQrCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReissueQrCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParkerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reissueQrCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parker"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parker"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"qrCode"}}]}}]}}]} as unknown as DocumentNode<ReissueQrCodeMutation, ReissueQrCodeMutationVariables>;
export const GetParkersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetParkers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParkerFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParkerSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"isProfileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}}]}}]}}]}}]} as unknown as DocumentNode<GetParkersQuery, GetParkersQueryVariables>;
export const RefreshParkerStripeDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshParkerStripeData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parkerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshParkerStripeData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parkerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parkerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"stripeDefaultPaymentMethodId"}}]}}]}}]} as unknown as DocumentNode<RefreshParkerStripeDataMutation, RefreshParkerStripeDataMutationVariables>;
export const GetSitesAndSiteParkersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSitesAndSiteParkers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteParkerFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteParkers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"parkerId"}},{"kind":"Field","name":{"kind":"Name","value":"isStrata"}},{"kind":"Field","name":{"kind":"Name","value":"canBook"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSitesAndSiteParkersQuery, GetSitesAndSiteParkersQueryVariables>;
export const AddPermanentParkerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPermanentParker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isStrata"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canBook"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPermanentParker"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isStrata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isStrata"}}},{"kind":"Argument","name":{"kind":"Name","value":"canBook"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canBook"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isStrata"}},{"kind":"Field","name":{"kind":"Name","value":"canBook"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AddPermanentParkerMutation, AddPermanentParkerMutationVariables>;
export const UpdatePermanentSiteParkerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePermanentSiteParker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteParker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteParkerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePermanentParker"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteParker"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteParker"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isStrata"}},{"kind":"Field","name":{"kind":"Name","value":"canBook"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePermanentSiteParkerMutation, UpdatePermanentSiteParkerMutationVariables>;
export const GetSiteParkersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSiteParkers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteParkerFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteParkers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"parkerId"}},{"kind":"Field","name":{"kind":"Name","value":"isStrata"}},{"kind":"Field","name":{"kind":"Name","value":"canBook"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<GetSiteParkersQuery, GetSiteParkersQueryVariables>;
export const GetPermissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPermission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permissionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permissionId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"myPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<GetPermissionQuery, GetPermissionQueryVariables>;
export const UpdatePermissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePermission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permission"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PermissionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePermission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permission"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<UpdatePermissionMutation, UpdatePermissionMutationVariables>;
export const GetPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<GetPermissionsQuery, GetPermissionsQueryVariables>;
export const DeletePermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePermission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeletePermissionsMutation, DeletePermissionsMutationVariables>;
export const GetPricePlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPricePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricePlanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"siteId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricePlanId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<GetPricePlanQuery, GetPricePlanQueryVariables>;
export const GetSiteWithAreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSiteWithAreas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSiteWithAreasQuery, GetSiteWithAreasQueryVariables>;
export const UpdatePricePlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePricePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricePlan"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PricePlanInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePricePlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pricePlan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricePlan"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<UpdatePricePlanMutation, UpdatePricePlanMutationVariables>;
export const GetPricePlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPricePlans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"siteId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<GetPricePlansQuery, GetPricePlansQueryVariables>;
export const GetTariffsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTariffs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}}]}}]}}]} as unknown as DocumentNode<GetTariffsQuery, GetTariffsQueryVariables>;
export const UpdateTariffsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTariffs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tariffs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TariffInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTariffs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tariffs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tariffs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}}]}}]} as unknown as DocumentNode<UpdateTariffsMutation, UpdateTariffsMutationVariables>;
export const GetProductsAndSitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductsAndSites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerHour"}},{"kind":"Field","name":{"kind":"Name","value":"maxPricePerDay"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"productTimesJson"}},{"kind":"Field","name":{"kind":"Name","value":"mustArriveBefore"}},{"kind":"Field","name":{"kind":"Name","value":"mustDepartAfter"}},{"kind":"Field","name":{"kind":"Name","value":"mustArriveAfter"}},{"kind":"Field","name":{"kind":"Name","value":"mustDepartBefore"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetProductsAndSitesQuery, GetProductsAndSitesQueryVariables>;
export const UpdateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerHour"}},{"kind":"Field","name":{"kind":"Name","value":"maxPricePerDay"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"productTimesJson"}},{"kind":"Field","name":{"kind":"Name","value":"mustArriveBefore"}},{"kind":"Field","name":{"kind":"Name","value":"mustDepartAfter"}},{"kind":"Field","name":{"kind":"Name","value":"mustArriveAfter"}},{"kind":"Field","name":{"kind":"Name","value":"mustDepartBefore"}}]}}]}}]} as unknown as DocumentNode<UpdateProductMutation, UpdateProductMutationVariables>;
export const GetEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EventFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startUtc"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEventsQuery, GetEventsQueryVariables>;
export const GetBehaviorViolationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBehaviorViolations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BehaviorViolationFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BehaviorViolationSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"behaviorViolations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"violationType"}},{"kind":"Field","name":{"kind":"Name","value":"detectedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"escalationScheduledUtc"}},{"kind":"Field","name":{"kind":"Name","value":"escalationScheduledUtc"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"escalationNotes"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startUtc"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBehaviorViolationsQuery, GetBehaviorViolationsQueryVariables>;
export const GetInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startUtc"}},{"kind":"Field","name":{"kind":"Name","value":"endUtc"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripeInvoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"stripeInvoicePdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"stripeError"}}]}}]}}]}}]} as unknown as DocumentNode<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"bayType"}},{"kind":"Field","name":{"kind":"Name","value":"isPermanentParker"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<GetReservationQuery, GetReservationQueryVariables>;
export const HaveCapacityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HaveCapacity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haveCapacity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"areaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reservationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haveCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<HaveCapacityQuery, HaveCapacityQueryVariables>;
export const UpdateReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReservationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReservation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reservation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"bayType"}},{"kind":"Field","name":{"kind":"Name","value":"isPermanentParker"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateReservationMutation, UpdateReservationMutationVariables>;
export const GetReservationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReservations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReservationFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReservationSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"startUtc"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endUtc"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isPermanentParker"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"bayType"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetReservationsQuery, GetReservationsQueryVariables>;
export const GetSiteCommandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSiteCommands"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteCommandFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteCommandSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteCommands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"response"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetSiteCommandsQuery, GetSiteCommandsQueryVariables>;
export const SiteCommandReceivedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SiteCommandReceived"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteCommandReceived"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode<SiteCommandReceivedSubscription, SiteCommandReceivedSubscriptionVariables>;
export const GetSiteMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSiteMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteMessageFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteMessageSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"response"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceId"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetSiteMessagesQuery, GetSiteMessagesQueryVariables>;
export const SiteMessageSentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SiteMessageSent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteMessageSent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"response"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceId"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SiteMessageSentSubscription, SiteMessageSentSubscriptionVariables>;
export const GetCapacitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCapacities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capacities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"permanent"}},{"kind":"Field","name":{"kind":"Name","value":"visitor"}},{"kind":"Field","name":{"kind":"Name","value":"strata"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<GetCapacitiesQuery, GetCapacitiesQueryVariables>;
export const UpdateCapacitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCapacities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"capacities"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CapacityInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCapacities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"capacities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"capacities"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"permanent"}},{"kind":"Field","name":{"kind":"Name","value":"visitor"}},{"kind":"Field","name":{"kind":"Name","value":"strata"}}]}}]}}]} as unknown as DocumentNode<UpdateCapacitiesMutation, UpdateCapacitiesMutationVariables>;
export const GetSitePermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSitePermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sitePermissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<GetSitePermissionsQuery, GetSitePermissionsQueryVariables>;
export const GetProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"productTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"hour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<GetProductsQuery, GetProductsQueryVariables>;
export const GetSiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"apiKey"}},{"kind":"Field","name":{"kind":"Name","value":"daysToStoreMessages"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isListed"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"lgaName"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeMessage"}},{"kind":"Field","name":{"kind":"Name","value":"gracePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"reservationBuffer"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"notificationEmails"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPhones"}},{"kind":"Field","name":{"kind":"Name","value":"immediateNotifications"}},{"kind":"Field","name":{"kind":"Name","value":"behaviourConfig"}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<GetSiteQuery, GetSiteQueryVariables>;
export const UpdateSiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"site"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apiKey"}},{"kind":"Field","name":{"kind":"Name","value":"daysToStoreMessages"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isListed"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"lgaName"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeMessage"}},{"kind":"Field","name":{"kind":"Name","value":"gracePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"reservationBuffer"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"notificationEmails"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPhones"}},{"kind":"Field","name":{"kind":"Name","value":"immediateNotifications"}},{"kind":"Field","name":{"kind":"Name","value":"behaviourConfig"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"}}]}}]}}]} as unknown as DocumentNode<UpdateSiteMutation, UpdateSiteMutationVariables>;
export const GetSitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lgaName"}},{"kind":"Field","name":{"kind":"Name","value":"isListed"}},{"kind":"Field","name":{"kind":"Name","value":"connectionId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSitesQuery, GetSitesQueryVariables>;
export const GetBaysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBays"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bays"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isOccupied"}},{"kind":"Field","name":{"kind":"Name","value":"isOverstay"}},{"kind":"Field","name":{"kind":"Name","value":"senseIqId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetBaysQuery, GetBaysQueryVariables>;
export const UpdateBayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bay"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BayInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bay"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bay"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isOccupied"}},{"kind":"Field","name":{"kind":"Name","value":"isOverstay"}},{"kind":"Field","name":{"kind":"Name","value":"senseIqId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<UpdateBayMutation, UpdateBayMutationVariables>;
export const TriggerRefreshDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TriggerRefresh"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"triggerRefresh"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<TriggerRefreshMutation, TriggerRefreshMutationVariables>;
export const BayUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"BayUpdated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bayUpdated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isOccupied"}},{"kind":"Field","name":{"kind":"Name","value":"isOverstay"}},{"kind":"Field","name":{"kind":"Name","value":"senseIqId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<BayUpdatedSubscription, BayUpdatedSubscriptionVariables>;
export const GetSitesForStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSitesForStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lgaName"}},{"kind":"Field","name":{"kind":"Name","value":"connectionId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSitesForStatusQuery, GetSitesForStatusQueryVariables>;
export const GetSiteConnectionEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSiteConnectionEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteConnectionEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"siteId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdUtc"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"connectionId"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"disconnectReason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetSiteConnectionEventsQuery, GetSiteConnectionEventsQueryVariables>;
export const SiteStatusUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SiteStatusUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lgaName"}},{"kind":"Field","name":{"kind":"Name","value":"connectionId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<SiteStatusUpdatedSubscription, SiteStatusUpdatedSubscriptionVariables>;
export const GetSitesAreasAndLanesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSitesAreasAndLanes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"senseIqId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pgsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessLanes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"senseIqId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fromAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"toAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"hasQrReader"}},{"kind":"Field","name":{"kind":"Name","value":"hasAnpr"}}]}}]}}]}}]} as unknown as DocumentNode<GetSitesAreasAndLanesQuery, GetSitesAreasAndLanesQueryVariables>;
export const GetTestingBaysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTestingBays"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bays"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isOccupied"}},{"kind":"Field","name":{"kind":"Name","value":"isOverstay"}},{"kind":"Field","name":{"kind":"Name","value":"senseIqId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<GetTestingBaysQuery, GetTestingBaysQueryVariables>;
export const SendMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"response"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceId"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}}]}}]} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>;
export const ClearSiteDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClearSiteData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clearSiteData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ClearSiteDataMutation, ClearSiteDataMutationVariables>;
export const BayTestingUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"BayTestingUpdated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bayUpdated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isOccupied"}},{"kind":"Field","name":{"kind":"Name","value":"isOverstay"}},{"kind":"Field","name":{"kind":"Name","value":"senseIqId"}}]}}]}}]} as unknown as DocumentNode<BayTestingUpdatedSubscription, BayTestingUpdatedSubscriptionVariables>;
export const GetTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transactionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"startUtc"}},{"kind":"Field","name":{"kind":"Name","value":"endUtc"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"parkerId"}},{"kind":"Field","name":{"kind":"Name","value":"vehicleId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"siteMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"response"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"behaviorViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"violationType"}},{"kind":"Field","name":{"kind":"Name","value":"detectedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"escalationScheduledUtc"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"escalationNotes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"stripeInvoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeInvoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"stripeInvoicePdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"stripeError"}},{"kind":"Field","name":{"kind":"Name","value":"stripeErrorUtc"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"stripeId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTransactionQuery, GetTransactionQueryVariables>;
export const ResetTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transactionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transactionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ResetTransactionMutation, ResetTransactionMutationVariables>;
export const TerminateTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TerminateTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"terminateTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transactionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transactionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isOnSite"}}]}}]}}]} as unknown as DocumentNode<TerminateTransactionMutation, TerminateTransactionMutationVariables>;
export const RetryStripeInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetryStripeInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retryStripeInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invoiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripeError"}}]}}]}}]} as unknown as DocumentNode<RetryStripeInvoiceMutation, RetryStripeInvoiceMutationVariables>;
export const GetTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"reservation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startUtc"}},{"kind":"Field","name":{"kind":"Name","value":"endUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isPerm"}},{"kind":"Field","name":{"kind":"Name","value":"isOnSite"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetTransactionsQuery, GetTransactionsQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const GetVehicleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVehicle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parkerId"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"colour"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isElectric"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"}}]}}]}}]}}]} as unknown as DocumentNode<GetVehicleQuery, GetVehicleQueryVariables>;
export const UpdateVehicleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVehicle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vehicle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VehicleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVehicle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"vehicle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vehicle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parkerId"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"colour"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isElectric"}},{"kind":"Field","name":{"kind":"Name","value":"createdUtc"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"}}]}}]}}]} as unknown as DocumentNode<UpdateVehicleMutation, UpdateVehicleMutationVariables>;
export const GetVehiclesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVehicles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VehicleFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VehicleSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parkerId"}},{"kind":"Field","name":{"kind":"Name","value":"parker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"colour"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isElectric"}}]}}]}}]}}]} as unknown as DocumentNode<GetVehiclesQuery, GetVehiclesQueryVariables>;